import { LocalStorageService } from "src/app/services/shared/local-storage/local-storage.service";
import { FuenteDinamicaDetailComponent } from "./fuente-dinamica-detail/fuente-dinamica-detail.component";
import { PreviewDataTableFuenteComponent } from "src/app/components/shared/previewDataTableFuente/previewDataTableFuente.component";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";

import { MatDialog } from '@angular/material/dialog';

import { GfdService } from "src/app/services/shared/gfd/gfd.service";
import {
  Component,
  ElementRef,
  OnInit,
  AfterViewInit,
  QueryList,
  ViewChild,
  ViewChildren,
  ViewEncapsulation,
  Injector,
  ChangeDetectorRef,
  afterNextRender,
  OnDestroy
} from "@angular/core";

import { ColumnMode, SelectionType } from "@swimlane/ngx-datatable";
import { EstructuraDinamicaField } from "src/app/entities/shared/EstructuraDinamicaField";
import { EstructuraDinamicaHeader } from "src/app/entities/shared/EstructuraDinamicaHeader";
import { ConfirmationDialogService } from "src/app/services/shared/confirmation-dialog/confirmation-dialog.service";
import { NotificationService } from "src/app/services/shared/notification/notification.service";
import { FuenteDinamicaService } from "src/app/services/shared/fuente-dinamica/fuente-dinamica.service";
import { FuenteDinamicaTelcoService } from "src/app/services/shared/fuente-dinamica/fuente-dinamica-telco.service";
import { ActivatedRoute, Router } from "@angular/router";
import { environment } from "src/environments/environment";
import { EntityDinamica } from "src/app/entities/shared/EntityDinamica";
import { Menu } from 'src/app/entities/shared/Menu';
import {forkJoin, firstValueFrom, Observable, ReplaySubject, tap, throwError, switchMap, Subscription} from 'rxjs';
//import { ModalSize } from "@signal/component-library/efx-modal";
import { SharedService } from 'src/app/services/shared/shared.service';
//import { TTypeSignalAlert } from "@signal/component-library/efx-alert/src/interfaces/efx-alert.interface";

import { DialogsService } from "../../../services/shared/dialogs.service";
import { TradeService } from "src/app/services/rd/trade.service";
import { BcraService } from "src/app/services/ar/bcra/bcra.service";
import { PersistenciaService } from "src/app/services/shared/persistencia-movimientos/persistencia.service";
import { EliminationPayloadService } from "src/app/services/ec/elimination-payload.service";
import { EcDisService } from "src/app/services/ec/ec-dis.service";
import { DoublePreviewService } from "src/app/services/shared/gfd-double-preview/double-preview.service";
import { RdsService } from "src/app/services/api/rds/rds.service";
import { AuditService } from "src/app/services/shared/audit/audit.service";
import { NotificationAlertService } from 'src/app/components/shared/notifications-alert/service/notifications-alert.service';

@Component({
  selector: "app-fuente-dinamica",
  templateUrl: "./fuente-dinamica.component.html",
  styleUrls: ["./fuente-dinamica.component.scss"],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class FuenteDinamicaComponent implements OnInit, OnDestroy, AfterViewInit {
  private routeParamsSub: Subscription | null = null;
  @ViewChild("listTable") listTable;
  @ViewChild("listTable2") listTable2: PreviewDataTableFuenteComponent;
  @ViewChildren("managetextfilter") filters: QueryList<ElementRef>;
  @ViewChild(FuenteDinamicaDetailComponent) fuenteDinamicaDetail!: FuenteDinamicaDetailComponent;
  private currentMenuConfig: any = null;
  showLoading: boolean = true;

  // Vista intermedia de configuraciones
  showConfigSelectionView: boolean = false;
  availableConfigs: any[] = [];
  selectedConfig: string | null = null;
  loadingConfigs: boolean = false;
  noConfigsAvailable: boolean = false;

  // Modal de configuraciones
  showConfigModal: boolean = false;
  selected = [];
  componentName = "FuenteDinamicaComponent";
  private configReady$ = new ReplaySubject<void>(1);
  private isConfigLoaded: boolean = false;
  buttonAdd: boolean = false;
  buttonAddTemplate: boolean = false;
  subDomainJO: string = '';
  domain: string = '';
  subdomain: string = '';
  editionMode: boolean = false;
  isEditing: boolean = false;
  fuenteDinamicaSelected: EntityDinamica;
  showEliminacionMasiva: boolean = false;
  showEliminacionMasivaSicomMicro: boolean = false;
  public formularioSchema: any[] = [];
  public avroSchema: any[] = [];

  // Habilita la lógica de múltiples vistas previas. Debes activarlo según la fuente.
  multiplePreview: boolean = false;
  // Controla la vista actual: la primera tabla, la segunda o el detalle.
  currentView: 'preview1' | 'preview2' | 'detail' = 'preview1';
  // Guarda la selección de la primera tabla para saber qué cargar en la segunda.
  lastPreview1Selection: any = null;

  // Datos y configuración para la segunda tabla de previsualización.
  dataVistaPrevia2: any[] = [];
  dataVistaPreviaFilter2: any[] = [];
  columnsVistaPrevia2: any[] = [];
  columnsNameData2: { columVar: string; columLabel: string }[] = [];

  service = null;
  baseUrlfuente = null;
  typeSearch = null;
  dominioSubDominioGKL: string = "";
  mensajeError: string = "";
  idHashDataAdded = '';
  counterExternalRDS: number = 0;

  // Valores de fallback del menú (para compatibilidad con configuraciones antiguas)
  private menuBaseUrlFallback: string | null = null;
  private menuBaseUrlTwoFallback: string | null = null;

  divSubDomainJO: {
    id: string;
    pascalCase: string;
    tituloPagina: string;
    permiteAnadir: boolean;
    permiteEliminar: boolean;
    vistaPrevia: any;
    columnsName: { columVar: string; columLabel: string }[];
    dataVistaPrevia: any;
    dataVistaPreviaFilter: any;
    showResultTable: boolean;
    showVistaDetalle: boolean;
    addPreview: boolean;
    deletePreview: boolean;
    bulkEditPreview: boolean;
    addPreviewTwo: boolean;
    deletePreviewTwo: boolean;
    bulkEditPreviewTwo: boolean;
  }[] = [];

  entroAGetEstructuraDinamica = false;
  entrarUnaVez = false;
  successDIS: boolean = false;

  ColumnMode = ColumnMode;
  SelectionType = SelectionType;
  searchTable: UntypedFormGroup;
  filterEvent: Event;
  viewSoftDeleted: boolean = false;
  addingObservatoin: boolean = false;
  showAddObservation: boolean = false;
  showBotonElimina: boolean = false;
  subTitle: string = "";
  primaryKeyFieldRdsVistaFD: string = "";
  primaryKeyFieldsRDS: string[] = []; // Array de campos que componen la primary key
  primaryKeySeparatorRDS: string = ""; // Separador para primary key compuesta
  dataviewsSchema: any;

  modalSize;
  matricesArray: string[];

  myMessages = {
    emptyMessage: "No se encontraron resultados",
    totalMessage: "Total",
    selectedMessage: "Seleccionados",
  };

  currentCountry = "";
  urlFuente: string;

  customClasses = {
    sortAscending: "fa fa-chevron-up datatable-icon-up",
    sortDescending: "fa fa-chevron-down datatable-icon-down",
    pagerLeftArrow: "fa fa-chevron-left datatable-paging-icons",
    pagerRightArrow: "fa fa-chevron-right datatable-paging-icons",
    pagerPrevious: "fa fa-step-backward datatable-paging-icons",
    pagerNext: "fa fa-step-forward datatable-paging-icons",
  };
  ///// temp update /////
  tempUpdate = {
    matchKeyOld: "",
    matchKeyNew: "",
    journaliTimeStatOld: "",
    journaliTimeStatNew: "",
  }

  ///// manuales /////
  disabledAddButton: boolean = false;
  disabledEditButton: boolean = false;
  fuentesManuales: any = {
    periods: false
  };
  isTelco = false;
  ultAporteFhTelco: number = 0;
  isRds = false;
  rdsContador = 0;

  function: any;
  showFunctionModal: boolean = false;
  functionModalTitle: string = 'Función';

  currentHistoryMatchKey: string = '';
  tradeFieldDefinitions: any[];

  get structField() {
    return this.localStorageService.getEstructuraDinamicaField || null;
  }

  private fuenteDinamicaService: FuenteDinamicaService;
  private fuenteDinamicaTelcoService: FuenteDinamicaTelcoService;
  private sharedService: SharedService;
  private confirmationDialogService: ConfirmationDialogService;
  private dialog: MatDialog;
  private notificationService: NotificationService;
  private router: Router;
  private activatedRoute: ActivatedRoute;
  private formBuilder: UntypedFormBuilder;
  private tradeService: TradeService;
  private bcraService: BcraService;
  private eliminationPayloadService: EliminationPayloadService;
  private ecDisService: EcDisService;
  private doublePreviewService: DoublePreviewService;
  private gfdService: GfdService;
  private cdr: ChangeDetectorRef;
  private rdsService: RdsService;
  private auditService: AuditService;
  private notificationAlertService: NotificationAlertService;
  private injector: Injector;

  constructor(
    injector: Injector,
    private localStorageService: LocalStorageService
  ) {
    // console.log('FuenteDinamicaComponent');
    this.injector = injector;
    this.fuenteDinamicaService = injector.get<FuenteDinamicaService>(FuenteDinamicaService);
    this.fuenteDinamicaTelcoService = injector.get<FuenteDinamicaTelcoService>(FuenteDinamicaTelcoService);
    this.sharedService = injector.get<SharedService>(SharedService);
    this.confirmationDialogService = injector.get<ConfirmationDialogService>(ConfirmationDialogService);
    this.dialog = injector.get<MatDialog>(MatDialog);
    this.notificationService = injector.get<NotificationService>(NotificationService);
    this.router = injector.get<Router>(Router);
    this.activatedRoute = injector.get<ActivatedRoute>(ActivatedRoute);
    this.formBuilder = injector.get<UntypedFormBuilder>(UntypedFormBuilder);
    this.matricesArray = this.localStorageService.getMatrizArray;
    this.localStorageService.setPrimarykeyRds = '';
    this.tradeService = injector.get<TradeService>(TradeService);
    this.bcraService = injector.get<BcraService>(BcraService);
    this.eliminationPayloadService = injector.get<EliminationPayloadService>(EliminationPayloadService);
    this.ecDisService = injector.get<EcDisService>(EcDisService);
    this.doublePreviewService = injector.get<DoublePreviewService>(DoublePreviewService);
    this.gfdService = injector.get<GfdService>(GfdService);
    this.cdr = injector.get<ChangeDetectorRef>(ChangeDetectorRef);
    this.rdsService = injector.get<RdsService>(RdsService);
    this.auditService = injector.get<AuditService>(AuditService);
    this.notificationAlertService = injector.get<NotificationAlertService>(NotificationAlertService);
  }

  ngOnInit(): void {
    if (this.localStorageService.getIsExternoRDS) {
      if (this.rdsContador === 0) {
        this.rdsContador++;
        const body = { data: this.localStorageService.getMatchkeySelected, type: 'primarykey' };
        this.loadRdsExternoFlow(body);
      }
    } else {
      this.ngOnInitMethod();
    }
    this.cdr.detectChanges();
  }

  private loadRdsExternoFlow(body: any) {
    this.divSubDomainJO = [];
    this.isEditing = false;
    this.successDIS = false;
    this.viewSoftDeleted = false;
    this.selected = [];
    this.currentCountry = this.sharedService.currentCountryValues().getCode();
    this.currentView = 'preview1';
    this.lastPreview1Selection = null;
    this.isTelco = false;
    this.isRds = true;
    this.createForm();

    const { domainJO, subDomainJO } = this.localStorageService.getDataSourceSelected;

    this.sharedService.getSchemasDataViewsShared(domainJO, subDomainJO).pipe(
      tap(result => {

        this.formularioSchema = result.fields.fieldConfiguration;
        this.avroSchema = result.fields.fieldConfiguration;
        const fields = result.fields;
        this.localStorageService.fields = fields;
        this.dataviewsSchema = fields.fieldConfiguration;
        this.localStorageService.setDataview = fields.fieldConfiguration;
        const separator = fields.primaryKey.separator;
        const primaryKey = fields.primaryKey.sourceFields.join(separator);
        this.localStorageService.setPrimaryKeyFieldRDS = primaryKey;
        this.primaryKeyFieldRdsVistaFD = primaryKey;
        this.primaryKeyFieldsRDS = fields.primaryKey.sourceFields || [];
        this.primaryKeySeparatorRDS = separator;
      }),
      switchMap(() => {
        const { domainJO: sourceDomain, subDomainJO: sourceSubdomain } = this.localStorageService.getDataSourceSelected;
        this.urlFuente = `${sourceDomain}/${sourceSubdomain}`;
        console.log('[loadRdsExternoFlow] URL Fuente construida:', this.urlFuente);

        const dataMenu: Menu[] = this.localStorageService.dataMenu;

        if (dataMenu === undefined) {
          throw new Error('No hay menú disponible');
        }

        let elementMenu = null;
        for (const menu of dataMenu) {
          const urlFuente = menu.domainJO + '/' + menu.subDomainJO;
          console.log('[loadRdsExternoFlow] Comparando:', {
            menuUrl: urlFuente.toLowerCase(),
            targetUrl: this.urlFuente.toLowerCase(),
            match: urlFuente?.toLowerCase() === this.urlFuente?.toLowerCase()
          });

          if (urlFuente?.toLowerCase() === this.urlFuente?.toLowerCase()) {
            elementMenu = menu;
            break;
          }
        }

        if (!elementMenu) {
          elementMenu = {
            domainJO: sourceDomain,
            subDomainJO: sourceSubdomain,
            service: null,
            typeSearch: null,
            baseUrl: null,
            baseUrlTwo: null,
            add: false,
            version: 0
          } as Menu;
        }

        this.currentMenuConfig = elementMenu;
        this.localStorageService.setMenuSelected = elementMenu;
        this.localStorageService.setDataSourceSelected = elementMenu;
        this.service = this.localStorageService.getRegionSeleccionada?.getService() || null;
        this.typeSearch = elementMenu.typeSearch || null;
        this.menuBaseUrlFallback = elementMenu.baseUrl || null;
        this.menuBaseUrlTwoFallback = elementMenu.baseUrlTwo || null;
        this.baseUrlfuente = null;
        this.dominioSubDominioGKL = this.urlFuente.toUpperCase();
        this.multiplePreview = false;
        this.subDomainJO = elementMenu.subDomainJO;
        this.domain = elementMenu.domainJO;
        this.subdomain = this.subDomainJO;

        const isRdsSource = elementMenu.domainJO && (elementMenu.domainJO.toUpperCase().startsWith('RDS_') || elementMenu.domainJO.toUpperCase() === 'RDS');

        if (isRdsSource) {
          const collection = `${elementMenu.domainJO}_${elementMenu.subDomainJO}`;
          return this.rdsService.getRdsGfdConfigs(collection);
        } else {
          return this.gfdService.getGfdConfigs(elementMenu.domainJO, elementMenu.subDomainJO);
        }
      }),
      tap((response) => {
        let configs = [];
        if (Array.isArray(response)) {
          configs = response;
        } else if (response?.data && Array.isArray(response.data)) {
          configs = response.data;
        } else if (response?.configs && Array.isArray(response.configs)) {
          configs = response.configs;
        }

        if (configs.length > 0) {
          this.availableConfigs = configs.map(config => ({
            name: typeof config === 'string' ? config : (config.configName || config.name || config),
            description: config.comentarios || config.description || 'Sin descripción'
          }));
          this.selectedConfig = this.availableConfigs[0].name;
        }
      }),
      switchMap(() => {
        return this.fuenteDinamicaService.getEstructuraDinamica(this.currentMenuConfig.domainJO, this.currentMenuConfig.subDomainJO);
      }),
      tap((listEstruct: any) => {
        if (!listEstruct || !listEstruct.header || !listEstruct.fields) {
          throw new Error('Estructura GFD inválida');
        }

        const headerData = listEstruct.header.map(el => new EstructuraDinamicaHeader().deserialize(el))[0];
        this.localStorageService.setEstructuraDinamicaHeader = headerData;
        this.localStorageService.setEstructuraDinamicaField = listEstruct.fields.map(el => new EstructuraDinamicaField().deserialize(el));

        this.baseUrlfuente = headerData.baseUrl || this.menuBaseUrlFallback || null;
        if (!this.baseUrlfuente && this.localStorageService.getIsExternoRDS) {
          this.baseUrlfuente = '/api/v4/sources/';
        }
        this.multiplePreview = !!(headerData.baseUrlTwo || this.menuBaseUrlTwoFallback);
      })
    ).subscribe({
      next: () => {
        this.onDataPrimarykeyRdsChange(body);
      },
      error: (err) => {
        this.notificationService.showError('Error al cargar la configuración de RDS');
        this.router.navigateByUrl(environment.URL_RETURN_APP_RDS);
      }
    });
  }

  ngAfterViewInit(): void {
    console.log('[ngAfterViewInit] Vista renderizada:', {
      showConfigSelectionView: this.showConfigSelectionView,
      availableConfigs: this.availableConfigs,
      loadingConfigs: this.loadingConfigs,
      divSubDomainJO_length: this.divSubDomainJO.length
    });
  }

  private ngOnInitMethod() {
    // console.log('FuenteDinamicaComponent ngOnInit');
    this.divSubDomainJO = [];
    this.isEditing = false;
    this.successDIS = false;
    this.viewSoftDeleted = false;
    this.idHashDataAdded = this.localStorageService.getMatchKeyData
      ? this.localStorageService.getMatchKeyData
      : '';
    this.selected = [];
    this.currentCountry = this.sharedService.currentCountryValues().getCode();
    this.inicioMethod();
    this.currentView = 'preview1';
    this.lastPreview1Selection = null;
    this.isTelco = this.localStorageService.getSourceCountrySelected === 'AR' &&
      this.localStorageService.getSourceDomainSelected === 'AR_EX_TELCO' &&
      this.localStorageService.getSourceSubDomainSelected === "PAYMENT";
    this.isRds = this.localStorageService.esInternoRDS || this.localStorageService.getIsExternoRDS;
    // console.log('ngOnInit ', this.idHashDataAdded);
    // console.log('this.isTelco', this.isTelco);
    // console.log('this.isRds', this.isRds);
    // console.log('%c ' + this.componentName + " / " + 'ngOnInit()', 'background: purple; color: white');
    this.createForm();
    this.loadSourceSchema();
  }

  loadSourceSchema(): void {
    // Para fuentes no-RDS (DIS Global) el schema se carga bajo demanda (lazy)
    // solo cuando se necesita en operaciones masivas. Ver ensureAvroSchemaLoaded().
    if (!this.isRds) {
      this.formularioSchema = this.localStorageService.getEstructuraDinamicaField;
      return;
    }

    const { domainJO, subDomainJO } = this.localStorageService.getDataSourceSelected;

    this.sharedService.getSchemasDataViewsShared(domainJO, subDomainJO).pipe(
      tap(result => {
        this.formularioSchema = result.fields.fieldConfiguration;
        this.avroSchema = result.fields.fieldConfiguration;
        const fields = result.fields;

        console.log('[loadSourceSchema] Es fuente RDS, cargando schema y dataview desde result.fields ----->', fields);
        this.localStorageService.fields = fields;
        this.dataviewsSchema = fields.fieldConfiguration;
        this.localStorageService.setDataview = fields.fieldConfiguration;
        const separator = fields.primaryKey.separator;
        const primaryKey = fields.primaryKey.sourceFields.join(separator);
        this.localStorageService.setPrimaryKeyFieldRDS = primaryKey;
        this.primaryKeyFieldRdsVistaFD = primaryKey;
        this.primaryKeyFieldsRDS = fields.primaryKey.sourceFields || [];
        this.primaryKeySeparatorRDS = separator;
      })
    ).subscribe({
      next: () => console.log('Schema y Dataview cargados exitosamente.'),
      error: err => console.error('Error al cargar el schema:', err)
    });
  }

  /**
   * Carga el avroSchema bajo demanda (lazy) para fuentes no-RDS.
   * Si ya está cargado, no hace nada. Se llama antes de operaciones masivas.
   */
  private async ensureAvroSchemaLoaded(): Promise<void> {
    if (this.avroSchema?.length > 0) return;

    const { domainJO, subDomainJO } = this.localStorageService.getDataSourceSelected;
    const result = await firstValueFrom(
      this.sharedService.getSchemasDataViewsShared(domainJO, subDomainJO)
    );

    const avroDefinition = JSON.parse(result.data.item.definition);
    this.avroSchema = avroDefinition.fields;
    this.localStorageService.fields = this.avroSchema;
    console.log('[ensureAvroSchemaLoaded] Schema cargado bajo demanda:', this.avroSchema.length, 'campos');
  }

  createForm(): void {
    this.searchTable = this.formBuilder.group({
      fuenteName: ["", Validators.required],
    });
  }

  goToFuentesPage() {
    let stringUrlSource = (this.localStorageService.getIsVip)
      ? 'vip/data-maintenance'
      : (this.localStorageService.getIsExternoRDS)
        ? 'rdsportal/data-maintenance'
        : 'int/data-maintenance';
    this.router.navigateByUrl(`/${stringUrlSource}/${this.currentCountry}/fuentes`);
  }

  isInvalid() {
    return this.fuenteDinamicaDetail?.formIsInvalid() || false;
  }

  get isEdicionMasivaDisabled(): boolean {
    // Para BCRA_FINANCIAL_STATUS, siempre está habilitado
    if (this.domain === 'AR_CREDIT' && this.subDomainJO === 'BCRA_FINANCIAL_STATUS') {
      return true;
    }

    // Para TRADE, se puede hacer ediciones masivas con 1 solo seleccionado
    if (this.domain === 'DO_CREDIT' && this.subDomainJO === 'TRADE' && this.selected.length > 0) {
      return true;
    }
    // Para otras fuentes, habilitar solo si hay más de 1 seleccionado
    return this.selected.length > 1;
  }

  onCreateData() {
    const data = {}

    if (this.localStorageService.getEstructuraDinamicaField != undefined) {
      this.localStorageService.getEstructuraDinamicaField.forEach(fields => {
        data[fields.name] = fields.inputType === "date" ? null : '';
      })
    }

    if (this.localStorageService.esAltaEntidades) {
      const buscadorSelect = this.localStorageService.getBuscadorSelect;
      const documentVar: string = buscadorSelect?.fieldDni;

      if (!documentVar) {
        console.warn('[onCreateData] No existe fieldDni en buscador seleccionado.');
      } else {
        data[documentVar] = this.localStorageService.getPersonaSelectedDni;
      }
    }

    this.buttonAddTemplate = true;
    const matchKey = this.fuenteDinamicaService.getCurrentPersons();
    if (matchKey?.entityKey == undefined) {
      data['matchKey'] = "";
    } else {
      data['matchKey'] = matchKey.entityKey;
    }

    return data;
  }

  inicioMethod() {
    // console.log("%c " + this.componentName + " / " + "inicioMethod(currentCountry: string)", "background: purple; color: white");
    // console.log("currentCountry :", this.currentCountry);

    if (this.currentCountry === undefined) {
      this.router.navigateByUrl(
        this.localStorageService.getIsVip
          ? environment.URL_RETURN_APP_VIP
          : this.localStorageService.getIsExternoRDS
            ? environment.URL_RETURN_APP_RDS
            : environment.URL_RETURN_APP
      );
    } else {
      this.obtenerFuenteDesdeRuta();
      const dataMenu: Menu[] = this.localStorageService.dataMenu;
      this.getEstructuraDinamicaCompruebaVersion(dataMenu);
    }
  }

  // TODO obtener fuente desde otra parte, no de la URL
  obtenerFuenteDesdeRuta() {
    let urlActualArray = (this.router.url === undefined || this.router.url === null) ?
      [""] :
      this.router.url.split("/");
    const lenghtUrl = urlActualArray?.length;
    let urlFound = lenghtUrl > 0 ? urlActualArray[lenghtUrl - 2] + '/' + urlActualArray[lenghtUrl - 1] : "";
    // if (this.localStorageService.getIsExternoRDS) {
    //   urlFound = lenghtUrl > 0 ? urlActualArray[lenghtUrl - 3] + '/' + urlActualArray[lenghtUrl - 2] : "";
    // }
    this.urlFuente = urlFound;

    // Evita apilar suscripciones a paramMap: cada llamada a este método
    // (disparada recursivamente vía ngOnInit al cambiar la ruta) reemplaza
    // la suscripción anterior en vez de sumarse a ella.
    this.routeParamsSub?.unsubscribe();
    this.routeParamsSub = this.activatedRoute.paramMap.subscribe(params => {
      const routeActivate = params.get('domain') + '/' + params.get('subDomain');
      // console.log("activatedRoute");

      if (routeActivate !== this.urlFuente) {
        // console.log("cambio la ruta");
        this.entrarUnaVez = false;
        this.ngOnInit();
      }
    })

    return urlFound;
  }

  ngOnDestroy(): void {
    this.routeParamsSub?.unsubscribe();
  }

  /**
   * Verifica si existe dataEstructuraHeaderX en storage, si no llama a getEstructuraDinamica()
   */
  getEstructuraDinamicaCompruebaVersion(dataMenuCountry: Menu[]) {
    if (dataMenuCountry === undefined) {
      this.router.navigateByUrl(
        this.localStorageService.getIsVip
          ? environment.URL_RETURN_APP_VIP
          : this.localStorageService.getIsExternoRDS
            ? environment.URL_RETURN_APP_RDS
            : environment.URL_RETURN_APP
      );
    } else {
      this.dataMenu(dataMenuCountry);
    }
  }

  dataMenu(
    dataMenuCountry: Menu[],
  ) {
    dataMenuCountry.forEach((elementMenu: Menu) => {

      // console.log('Verificando Menú:', elementMenu);

      const urlFuente = elementMenu.domainJO + '/' + elementMenu.subDomainJO;
      if (urlFuente?.toLowerCase() === this.urlFuente?.toLowerCase()) {

        // console.log('%cConfiguración ENCONTRADA Y GUARDADA:', 'color: green; font-weight: bold;', elementMenu);

        // rescata sólo el objeto que coincide con la ruta url
        // if (elementMenu.dinamica) {
        this.currentMenuConfig = elementMenu;
        this.localStorageService.setMenuSelected = elementMenu;
        this.localStorageService.setDataSourceSelected = elementMenu;
        this.service = this.localStorageService.getRegionSeleccionada?.getService() || null;
        this.typeSearch = elementMenu.typeSearch != undefined ? elementMenu.typeSearch : null;

        // Guardar baseUrl y baseUrlTwo del menú como fallback (para compatibilidad con configuraciones antiguas)
        // La prioridad será: 1) header de GFD, 2) menú (fallback)
        this.menuBaseUrlFallback = elementMenu.baseUrl || null;
        this.menuBaseUrlTwoFallback = elementMenu.baseUrlTwo || null;

        console.log('[initFuentesDinamicasActivas] Valores del menú guardados como fallback:', {
          menuBaseUrlFallback: this.menuBaseUrlFallback,
          menuBaseUrlTwoFallback: this.menuBaseUrlTwoFallback
        });

        // NOTA: baseUrl y baseUrlTwo se leen del header de GFD cuando se carga la estructura
        // Se inicializan a null aquí y se asignan después de cargar la estructura
        // Si no existen en el header, se usarán los valores del menú como fallback
        this.baseUrlfuente = null;
        //this.showAddObservation = elementMenu.add;
        //this.showBotonElimina = elementMenu.delete;
        this.dominioSubDominioGKL = urlFuente.toUpperCase();

        // multiplePreview se determina después de cargar el header de GFD
        this.multiplePreview = false;
        this.subDomainJO = elementMenu.subDomainJO;
        /// purposing ////
        this.domain = elementMenu.domainJO;
        this.subdomain = this.subDomainJO;

        // checkAvailableConfigs dispara la cadena asincrona que termina en traeDataPreview(),
        // por lo que domain/subdomain deben estar asignados antes de llamarlo.
        this.checkAvailableConfigs(elementMenu);

        if (this.domain === 'DO_CREDIT' && this.subDomainJO === 'TRADE') {
          this.tradeFieldDefinitions = this.tradeService.getTradeFieldDefinitions();
        }
      }
    });
  }

  /**
   * Consulta las configuraciones disponibles para la fuente
   * Si hay más de una, muestra la vista intermedia
   * Si hay solo una, entra directamente
   */
  checkAvailableConfigs(elementMenu: any) {
    // Guardar elementMenu para poder usarlo después desde el modal
    this.currentMenuConfig = elementMenu;

    this.loadingConfigs = true;
    const domain = elementMenu.domainJO;
    const subdomain = elementMenu.subDomainJO;

    // Detectar si es una fuente RDS por su domainJO (comienza con 'RDS_')
    const isRdsSource = domain && (domain.toUpperCase().startsWith('RDS_') || domain.toUpperCase() === 'RDS');

    console.log('[checkAvailableConfigs] Verificando fuente:', { domain, subdomain, isRdsSource });

    if (isRdsSource) {
      console.log('[checkAvailableConfigs]  Fuente RDS detectada, usando servicios RDS');
      // Para RDS, la collection es la concatenación de domain + subdomain
      const collection = `${domain}_${subdomain}`;
      console.log('[checkAvailableConfigs] Collection RDS:', collection);
      this.checkRdsConfigs(elementMenu, collection);
      return;
    }

    // Flujo normal para GFD
    console.log('[checkAvailableConfigs] Flujo normal GFD');
    this.gfdService.getGfdConfigs(domain, subdomain).subscribe({
      next: (response) => {
        console.log('[checkAvailableConfigs] Configuraciones disponibles:', response);

        // El backend devuelve un array directamente: [{ configName: "Alpha", comentarios: "..." }, ...]
        let configs = [];

        if (Array.isArray(response)) {
          // Respuesta es un array directo
          configs = response;
        } else if (response?.configs && Array.isArray(response.configs)) {
          // Respuesta es un objeto con propiedad configs
          configs = response.configs;
        }

        if (configs.length > 0) {
          // Normalizar el formato: { name, description }
          this.availableConfigs = configs.map(config => ({
            name: config.configName || config.name || config,
            description: config.comentarios || config.description || 'Sin descripción'
          }));

          if (this.availableConfigs.length > 1) {
            // Hay múltiples configuraciones
            this.localStorageService.setHasMultipleGfdConfigs = true;

            // Verificar si ya hay una configuración seleccionada en localStorage
            // (por ejemplo, desde el modal de fuentesMenu)
            const preSelectedConfig = this.localStorageService.getSelectedGfdConfig;
            console.log('[checkAvailableConfigs] Config pre-seleccionada desde localStorage:', preSelectedConfig);

            if (preSelectedConfig) {
              // Ya hay una configuración seleccionada, cargarla directamente
              console.log('[checkAvailableConfigs]  Usando config pre-seleccionada:', preSelectedConfig);
              this.selectedConfig = preSelectedConfig;
              this.loadingConfigs = false;
              this.loadConfigAndContinue(elementMenu, preSelectedConfig);
            } else {
              // No hay configuración pre-seleccionada, cargar la primera por defecto
              // (el usuario puede cambiarla luego con el botón de cambiar config)
              console.log('[checkAvailableConfigs]  No hay config pre-seleccionada, usando la primera');
              this.selectedConfig = this.availableConfigs[0].name;
              this.localStorageService.setSelectedGfdConfig = this.selectedConfig;
              this.loadingConfigs = false;
              this.loadConfigAndContinue(elementMenu, this.selectedConfig);
            }
          } else if (this.availableConfigs.length === 1) {
            // Solo hay una configuración, entrar directamente (NO mostrar selector)
            this.localStorageService.setHasMultipleGfdConfigs = false;
            this.selectedConfig = this.availableConfigs[0].name;
            this.loadConfigAndContinue(elementMenu, this.selectedConfig);
          }
        } else {
          // No hay configuraciones disponibles - mostrar error
          console.error('[checkAvailableConfigs]  No se encontraron configuraciones para esta fuente');
          this.loadingConfigs = false;
          this.noConfigsAvailable = true;
        }
      },
      error: (error) => {
        console.error('[checkAvailableConfigs] Error al obtener configuraciones:', `Código: ${error?.status}, Mensaje: ${error?.message}`);
        // No hay configuraciones disponibles - mostrar pantalla de error
        this.loadingConfigs = false;
        this.showLoading = false;
        this.noConfigsAvailable = true;
      }
    });
  }

  /**
   * Verifica configuraciones disponibles específicamente para fuentes RDS
   */
  private checkRdsConfigs(elementMenu: any, collection: string) {
    console.log('[checkRdsConfigs] collection:', collection);
    this.rdsService.getRdsGfdConfigs(collection).subscribe({
      next: (response) => {
        let configs = [];
        if (Array.isArray(response)) {
          configs = response;
        } else if (response?.data && Array.isArray(response.data)) {
          configs = response.data;
        } else if (response?.configs && Array.isArray(response.configs)) {
          configs = response.configs;
        }

        if (configs.length > 0) {
          // Normalizar el formato
          this.availableConfigs = configs.map(config => ({
            name: typeof config === 'string' ? config : (config.configName || config.name || config),
            description: config.comentarios || config.description || 'Sin descripción'
          }));

          if (this.availableConfigs.length > 1) {
            // Múltiples configuraciones RDS
            this.localStorageService.setHasMultipleGfdConfigs = true;

            const preSelectedConfig = this.localStorageService.getSelectedRdsConfig;
            console.log('[checkRdsConfigs] Config RDS pre-seleccionada:', preSelectedConfig);

            if (preSelectedConfig) {
              console.log('[checkRdsConfigs]  Usando config RDS pre-seleccionada:', preSelectedConfig);
              this.selectedConfig = preSelectedConfig;
              this.loadingConfigs = false;
              this.loadConfigAndContinue(elementMenu, preSelectedConfig);
            } else {
              console.log('[checkRdsConfigs]  No hay config pre-seleccionada, usando la primera');
              this.selectedConfig = this.availableConfigs[0].name;
              this.localStorageService.setSelectedRdsConfig = this.selectedConfig;
              this.loadingConfigs = false;
              this.loadConfigAndContinue(elementMenu, this.selectedConfig);
            }
          } else if (this.availableConfigs.length === 1) {
            // Una sola configuración RDS
            this.localStorageService.setHasMultipleGfdConfigs = false;
            this.selectedConfig = this.availableConfigs[0].name;
            this.localStorageService.setSelectedRdsConfig = this.selectedConfig;
            this.loadConfigAndContinue(elementMenu, this.selectedConfig);
          }
        } else {
          console.error('[checkRdsConfigs]  No se encontraron configs RDS');
          this.loadingConfigs = false;
          this.noConfigsAvailable = true;
        }
      },
      error: (error) => {
        console.error('[checkRdsConfigs]  Error al obtener configs RDS:', error);
        this.loadingConfigs = false;
        this.showLoading = false;
        this.noConfigsAvailable = true;
      }
    });
  }

  /**
   * Maneja la selección de una configuración desde la vista intermedia
   */
  onConfigSelected(config: any) {
    const configName = config.name;

    this.selectedConfig = configName;
    // Guardar la configuración seleccionada para que el breadcrumb la muestre
    this.localStorageService.setSelectedGfdConfig = configName;
    // Forzar actualización del breadcrumb
    this.localStorageService.triggerBreadcrumbUpdate();
    this.showConfigSelectionView = false;
    this.showLoading = true;

    this.loadConfigAndContinue(this.currentMenuConfig, configName);
  }

  /**
   * Carga la configuración seleccionada y continúa con el flujo normal
   */
  private loadConfigAndContinue(elementMenu: any, configName: string) {
    this.selectedConfig = configName;

    // Detectar si es RDS y guardar en el storage apropiado
    const isRdsSource = elementMenu.baseUrl && elementMenu.baseUrl.includes('/rds/');
    if (isRdsSource) {
      this.localStorageService.setSelectedRdsConfig = configName;
    } else {
      this.localStorageService.setSelectedGfdConfig = configName;
    }

    this.callGetEstructuraDinamica(elementMenu);
    this.loadingConfigs = false;
  }

  /**
   * Volver a la vista de selección de configuraciones
   */
  backToConfigSelection() {
    if (!this.availableConfigs || this.availableConfigs.length === 0) {
      console.error('[backToConfigSelection] No hay configuraciones disponibles.');
      this.notificationService.showError('No se puede volver al selector de configuraciones.');
      return;
    }

    // Limpiar la configuración seleccionada para volver a mostrar solo el nombre de la fuente
    this.localStorageService.setSelectedGfdConfig = null;
    this.selectedConfig = null;

    // Forzar actualización del breadcrumb
    this.localStorageService.triggerBreadcrumbUpdate();

    // Limpiar las tablas para que no se muestren
    this.divSubDomainJO = [];

    // Limpiar el storage de estructura dinámica para forzar recarga con nueva config
    this.localStorageService.setEstructuraDinamicaHeader = undefined;
    this.localStorageService.setEstructuraDinamicaField = undefined;

    // Resetear estado de selección y edición
    this.selected = [];
    this.isEditing = false;
    this.addingObservatoin = false;
    this.currentView = 'preview1';

    // IMPORTANTE: Resetear entrarUnaVez para permitir que se vuelva a cargar la estructura
    this.entrarUnaVez = false;
    this.entroAGetEstructuraDinamica = false;

    // Mostrar la vista de selección de configuración
    this.showConfigSelectionView = true;
    this.showLoading = false;
    this.loadingConfigs = false;

    this.cdr.detectChanges();
    setTimeout(() => this.cdr.detectChanges(), 100);
  }

  /**
   * Abre el modal de selección de configuraciones
   */
  openConfigModal() {
    console.log('[openConfigModal]  Abriendo modal de configuraciones');
    console.log('[openConfigModal] availableConfigs:', this.availableConfigs);

    if (!this.availableConfigs || this.availableConfigs.length === 0) {
      console.warn('[openConfigModal] No hay configuraciones disponibles');
      this.notificationService.showInfo('No hay configuraciones disponibles');
      return;
    }

    this.showConfigModal = true;
  }

  /**
   * Cierra el modal de selección de configuraciones
   */
  closeConfigModal() {
    console.log('[closeConfigModal] Cerrando modal');
    this.showConfigModal = false;
  }

  /**
   * Vuelve al selector de fuentes cuando no hay configuraciones disponibles
   */
  backToSourceSelector() {
    console.log('[backToSourceSelector] Volviendo al selector de fuentes');
    this.noConfigsAvailable = false;
    const stringUrlSource = (this.localStorageService.getIsVip)
      ? 'vip/data-maintenance'
      : (this.localStorageService.getIsExternoRDS)
        ? 'rdsportal/data-maintenance'
        : 'int/data-maintenance';
    this.router.navigateByUrl(`/${stringUrlSource}/${this.currentCountry}/fuentes`);
  }

  /**
   * Maneja la selección de configuración desde el modal
   */
  onModalConfigSelected(config: any) {
    console.log('[onModalConfigSelected]  Configuración seleccionada desde modal:', config);

    const configName = config.name || config;

    // Si ya está cargada esta configuración, no hacer nada
    if (this.selectedConfig === configName) {
      console.log('[onModalConfigSelected] La configuración ya está cargada');
      this.closeConfigModal();
      return;
    }

    // Limpiar estado actual
    this.divSubDomainJO = [];
    this.selected = [];
    this.isEditing = false;
    this.currentView = 'preview1';
    this.entrarUnaVez = false;
    this.entroAGetEstructuraDinamica = false;

    // Actualizar configuración seleccionada
    this.selectedConfig = configName;
    this.localStorageService.setSelectedGfdConfig = configName;
    this.localStorageService.triggerBreadcrumbUpdate();

    // Ocultar vista de selección si estaba visible
    this.showConfigSelectionView = false;
    this.showLoading = true;

    // Cargar la nueva configuración
    const elementMenu = this.currentMenuConfig || this.localStorageService.getDataSourceSelected;
    this.loadConfigAndContinue(elementMenu, configName);

    // Cerrar modal
    this.closeConfigModal();
  }

  /**
   * Verifica si existe dataEstructuraHeaderX en storage, si no llama a getEstructuraDinamica()
   */
  callGetEstructuraDinamica(elementMenu: any) {
    this.buttonAdd = elementMenu.add;
    this.subDomainJO = elementMenu.subDomainJO;

    const { periods, periodsSection, periodsType, domainJO } = elementMenu;

    this.fuentesManuales = {
      periods,
      periodsSection,
      periodsType,
      domainJO
    }

    let subDomainJOArraySubDomainJO = elementMenu.subDomainJO !== undefined
      ? elementMenu.subDomainJO.split(",")
      : [];
    const subDomainJOArray =
      elementMenu !== undefined ? subDomainJOArraySubDomainJO : [];
    this.entroAGetEstructuraDinamica = false;

    subDomainJOArray.forEach((subDomainJoSplit) => {
      let fuentePascalCase =
        this.sharedService.convertSnakeCaseToPascalCase(subDomainJoSplit);

      if (!this.entroAGetEstructuraDinamica) {
        this.callGetEstructuraDinamicaRefactor(
          this.localStorageService.dataEstructuraDinamicaHeader,
          elementMenu
        );
      }
    });
  }

  callGetEstructuraDinamicaRefactor(
    dataEstructuraHeader: EstructuraDinamicaHeader,
    elementMenu: any,
  ) {
    if (
      dataEstructuraHeader === undefined ||
      !(environment.CONSUME_API_ESTRUCTURA.toString().toLowerCase() === "true")
    ) {
      this.getEstructuraDinamica(
        elementMenu.subDomainJO,
        elementMenu.domainJO
      );
      this.entroAGetEstructuraDinamica = true;
    } else {
      // si está en storage va a comprobar la versión
      if (
        elementMenu.version >= dataEstructuraHeader.version &&
        !this.entroAGetEstructuraDinamica
      ) {
        // comprueba si no hay cambio de version
        this.getEstructuraDinamica(
          elementMenu.subDomainJO,
          elementMenu.domainJO
        );
        this.entroAGetEstructuraDinamica = true;
      } else {
        this.hacerLuegoDeGetEstructuraDinamica(
          elementMenu.subDomainJO
        ); // String JOs separado por comas
      }
    }
  }

  /**
   * Escribe la data de MENU_COUNTRY en storage dataEstructuraHeaderX y dataEstructuraFieldsX
   * y retorna un observable que notifica cuando la operación ha terminado.
   */
  getEstructuraDinamica(
    subDomainJo: string,
    domainJO: string
  ): Observable<any> {
    // console.log("%c " + this.componentName + " , " + "getEstructuraDinamica(subDomainJo, domainJO)", "background:orange; color: black");

    if (subDomainJo === '') {
      return throwError(() => new Error("Estructura dinámica no encontrada: subDomainJo está vacío."));
    }

    this.fuenteDinamicaService.getEstructuraDinamica(domainJO, subDomainJo).subscribe(
      (listEstruct: any) => {
        // El servicio GFD ahora devuelve directamente el objeto, no envuelto en otra clave
        // Verificar si la respuesta tiene la estructura esperada
        if (!listEstruct || !listEstruct.header || !listEstruct.fields) {
          console.error('Estructura GFD inválida:', listEstruct);
          return;
        }

        const subDomainJOArray = (subDomainJo !== undefined) ? subDomainJo.split(',') : [];

        // Acceder directamente a manualVariants
        const manualVariants = Object.prototype.hasOwnProperty.call(listEstruct, 'manualVariants')
          ? listEstruct.manualVariants
          : null;

        this.fuentesManuales['manualVariants'] = manualVariants;
        this.localStorageService.setManualVariants = manualVariants;

        subDomainJOArray.forEach(subDomainJoSplitFull => {
          const subDomainJoSplit = this.sharedService.getEndpoint(subDomainJoSplitFull);
          // Acceder directamente a header y fields
          const headerData = listEstruct.header.map(el => new EstructuraDinamicaHeader().deserialize(el))[0];
          this.localStorageService.setEstructuraDinamicaHeader = headerData;
          this.localStorageService.setEstructuraDinamicaField = listEstruct.fields.map(el => new EstructuraDinamicaField().deserialize(el));

          // Leer baseUrl y baseUrlTwo del header de GFD con fallback al menú
          // PRIORIDAD: 1) header de GFD, 2) menú (fallback para configuraciones antiguas)
          this.baseUrlfuente = headerData.baseUrl || this.menuBaseUrlFallback || null;
          this.multiplePreview = !!(headerData.baseUrlTwo || this.menuBaseUrlTwoFallback);

          console.log('[loadEstructuraDinamica] baseUrl y baseUrlTwo asignados:', {
            fromHeader: {
              baseUrl: headerData.baseUrl,
              baseUrlTwo: headerData.baseUrlTwo
            },
            fromMenuFallback: {
              baseUrl: this.menuBaseUrlFallback,
              baseUrlTwo: this.menuBaseUrlTwoFallback
            },
            finalValues: {
              baseUrlfuente: this.baseUrlfuente,
              multiplePreview: this.multiplePreview
            },
            usedFallback: !headerData.baseUrl
          });
        });
        this.hacerLuegoDeGetEstructuraDinamica(
          subDomainJo
        );
      });
  }

  loadEstructuraParaDetalle(subDomainJo: string, domainJO: string): Observable<void> {
    // console.log(`%c Cargando estructura SOLO para VISTA DETALLE:`, "background:purple; color: white", { subDomainJo, domainJO });

    return this.fuenteDinamicaService.getEstructuraDinamica(domainJO, subDomainJo).pipe(
      tap((listEstruct: any) => {
        // console.log("Estructura recibida, guardando en localStorage...", listEstruct);
        try {
          // El servicio GFD ahora devuelve directamente el objeto
          if (!listEstruct || !listEstruct.header || !listEstruct.fields) {
            throw new Error('Estructura GFD inválida');
          }

          this.localStorageService.setEstructuraDinamicaHeader = listEstruct.header.map(el => new EstructuraDinamicaHeader().deserialize(el))[0];
          this.localStorageService.setEstructuraDinamicaField = listEstruct.fields.map(el => new EstructuraDinamicaField().deserialize(el));
          // console.log("Estructura para detalle guardada exitosamente.");
        } catch (error) {
          console.error("Falló el guardado de la estructura para detalle:", error);
          throw error;
        }
      })
    );
  }

  // with this get the format and rules of every attribute in the source
  getEstructuraDinamicaSession(subDomainJOArray: string[], domainJO: string, subDomainJo: string) {
    // console.log("%c " + this.componentName + " , " + " getEstructuraDinamicaSession(subDomainJOArray: string[], domainJO: string, subDomainJo: string)", "background:orange; color: black");
    // console.log("subDomainJOArray : ", subDomainJOArray);
    // console.log("domainJO : ", domainJO);
    // console.log("subDomainJo : ", subDomainJo);

    this.fuenteDinamicaService.getEstructuraDinamica(domainJO, subDomainJo).subscribe(
      (listEstruct: any) => {
        // El servicio GFD ahora devuelve directamente el objeto
        if (!listEstruct || !listEstruct.header || !listEstruct.fields) {
          console.error('Estructura GFD inválida:', listEstruct);
          return;
        }

        // fuente manuales 2
        const manualVariants = Object.prototype.hasOwnProperty.call(listEstruct, 'manualVariants')
          ? listEstruct.manualVariants
          : null;

        this.fuentesManuales['manualVariants'] = manualVariants;
        this.localStorageService.setManualVariants = manualVariants;
        // console.log("this.fuentesManuales ----->", this.fuentesManuales);
        // fin fuentes manuales 2

        subDomainJOArray.forEach(subDomainJoSplitFull => {
          const subDomainJoSplit = this.sharedService.getEndpoint(subDomainJoSplitFull);
          const fuentePascalCase = this.sharedService.convertSnakeCaseToPascalCase(subDomainJoSplit);
          // console.log('fuentePascalCase ', fuentePascalCase);

          const headerData = listEstruct.header.map(el => new EstructuraDinamicaHeader().deserialize(el))[0];
          this.localStorageService.setEstructuraDinamicaHeader = headerData;
          this.localStorageService.setEstructuraDinamicaField = listEstruct.fields.map(el => new EstructuraDinamicaField().deserialize(el));

          // Leer baseUrl y baseUrlTwo del header de GFD con fallback al menú
          // PRIORIDAD: 1) header de GFD, 2) menú (fallback para configuraciones antiguas)
          this.baseUrlfuente = headerData.baseUrl || this.menuBaseUrlFallback || null;
          this.multiplePreview = !!(headerData.baseUrlTwo || this.menuBaseUrlTwoFallback);

          console.log('[getEstructuraDinamicaSession] baseUrl y baseUrlTwo asignados:', {
            fromHeader: {
              baseUrl: headerData.baseUrl,
              baseUrlTwo: headerData.baseUrlTwo
            },
            fromMenuFallback: {
              baseUrl: this.menuBaseUrlFallback,
              baseUrlTwo: this.menuBaseUrlTwoFallback
            },
            finalValues: {
              baseUrlfuente: this.baseUrlfuente,
              multiplePreview: this.multiplePreview
            },
            usedFallback: !headerData.baseUrl
          });
        });
        this.hacerLuegoDeGetEstructuraDinamica(
          subDomainJo
        );
      });
  }

  /**
   * Operaciones que se realizan en esta vista luego de estar lleno dataEstructuraHeaderX y dataEstructuraFields
   * subDomainJO: String JO separado por comas
   */
  hacerLuegoDeGetEstructuraDinamica(
    subDomainJoFull: string,
  ) {
    // console.log("%c " + this.componentName + " / " + "hacerLuegoDeGetEstructuraDinamica(subDomainJoFull, route, currentCountry)", "background: orange; color: black");
    // console.log("!this.entrarUnaVez : ", !this.entrarUnaVez);
    // console.log("subDomainJoFull OK : ", subDomainJoFull);

    if (!this.entrarUnaVez) {
      this.entrarUnaVez = true;

      const { periodsType } = this.fuentesManuales;
      const periods = this.fuentesManuales.periods ? this.fuentesManuales.periods : false;

      if (periods && periodsType && periodsType === "situation") {

        if (this.fuentesManuales.hasOwnProperty('manualVariants')) {
          const subDomainsManuals = this.fuentesManuales.manualVariants.method.flatMap(item => item.type);
          const subDomainsManualsLength = subDomainsManuals.length;

          this.fuentesManuales["subDomainsManuals"] = subDomainsManuals;
          this.fuentesManuales["subDomainsManualsLength"] = subDomainsManualsLength;
          this.fuentesManuales["listData"] = {};

          if (subDomainsManualsLength > 0) {
            this.callAllsSubDomains(subDomainsManuals, periods, true);
          }

        }

      } else {
        this.fillEstructuraDinamicaHeaderAndColumnsVistaPrevia(
          subDomainJoFull
        );
      }

      this.fillEstructuraDinamicaFields();
    }

    // Notificar que la configuración está lista para RDS externo
    if (this.localStorageService.getIsExternoRDS && !this.isConfigLoaded) {
      this.isConfigLoaded = true;
      console.log('[hacerLuegoDeGetEstructuraDinamica] Configuración completa, emitiendo configReady$');
      this.configReady$.next();
      console.log('[hacerLuegoDeGetEstructuraDinamica] configReady$ emitido exitosamente');
    }
  }

  fillEstructuraDinamicaHeaderAndColumnsVistaPrevia(
    subDomainJoFull: string
  ) {
    // console.log("%c " + this.componentName + " / " + "fillEstructuraDinamicaHeaderAndColumnsVistaPrevia(subDomainJo, route, currentCountry)", "background: orange; color: black");
    // console.log("subDomainJoFull :", subDomainJoFull);
    // console.log("route :", this.urlFuente);

    if (this.localStorageService.esAltaEntidades || this.isRds) { // no carga data de esta fuente al ingresar a vista previa
      this.avanzarPreview([], subDomainJoFull);
    } else {
      this.traeDataPreview(subDomainJoFull);
    }
  }

  /**
   * Resuelve el dominio para purposing. this.domain solo se asigna cuando la ruta hace match
   * en dataMenu(); si eso no ocurre se cae al header de GFD o a la ruta actual, evitando
   * construir una URL con el segmento vacio (.../UY//PURP_...).
   */
  private resolveDomain(): string {
    const header: any = this.localStorageService.dataEstructuraDinamicaHeader;
    return this.domain
      || header?.domain
      || header?.domaine?.split('/')[0]
      || this.dominioSubDominioGKL?.split('/')[0]
      || this.urlFuente?.toUpperCase().split('/')[0]
      || "";
  }

  async traeDataPreview(subDomainJoFull: string) {
    const periodsField = this.localStorageService.dataEstructuraDinamicaHeader?.periodsMatchKeyField;

    const baseURL = this.baseUrlfuente || "";
    const country = this.currentCountry || "";


    const header = this.localStorageService.dataEstructuraDinamicaHeader;

    const subDomainPurp = header?.subdomainPurp || "";

    if (baseURL.includes('/purp')) {
      const domain = this.resolveDomain();
      const subdomain = this.subdomain || header?.subDomainPP || this.subDomainJO || "";

      console.log('[traeDataPreview] Detectado servicio PURP:', {
        baseURL,
        subDomainPurp,
        domain,
        subdomain
      });

      if (!domain) {
        console.error('[traeDataPreview] No se pudo resolver el dominio, se aborta la llamada a purposing');
        this.avanzarPreview([], subDomainJoFull);
        return;
      }

      const entityKey = this.localStorageService.getPersonaSelected.entityKey;
      this.localStorageService.subdomainPurp = subDomainPurp;

      this.fuenteDinamicaService.getPurposing(baseURL, country, domain, subDomainPurp, entityKey, subdomain).subscribe({
        next: (listData: any) => {
          if (listData && listData.hasOwnProperty('payload')) {
            let data = listData.payload[this.subdomain] || [];
            this.avanzarPreview(data, subDomainJoFull);
          } else {
            this.avanzarPreview([], subDomainJoFull);
          }

        },
        error: _error => {
          this.avanzarPreview([], subDomainJoFull);
        }
      });
    } else {
      console.log('[traeDataPreview]  Flujo normal (no PURP)');
      console.log('[traeDataPreview] Llamando a getDataFuenteDinamicaList con:', {
        subDomainJoFull,
        urlFuente: this.urlFuente,
        currentCountry: this.currentCountry,
        typeSearch: this.typeSearch,
        dominioSubDominioGKL: this.dominioSubDominioGKL,
        baseUrlfuente: this.baseUrlfuente,
        idHashDataAdded: this.idHashDataAdded,
        periodsField
      });

      this.localStorageService.subdomainPurp = "";
      this.fuenteDinamicaService.getDataFuenteDinamicaList(
        subDomainJoFull,
        this.urlFuente,
        this.currentCountry,
        this.typeSearch,
        this.dominioSubDominioGKL,
        this.baseUrlfuente,
        false,
        this.idHashDataAdded,
        periodsField,
        false
      ).subscribe({
        next: (listData: any[]) => {
          console.log('[traeDataPreview]  Respuesta recibida del servicio:', {
            listDataType: typeof listData,
            isArray: Array.isArray(listData),
            length: listData?.length,
            listData: listData
          });

          this.avanzarPreview(listData, subDomainJoFull);
        },
        error: _error => {
          console.error('[traeDataPreview]  Error en getDataFuenteDinamicaList:', _error);
          this.avanzarPreview([], subDomainJoFull);
        }
      });

    }
    this.showLoading = false;
  }

  avanzarPreview(listData: any, subDomainJoFull) {
    setTimeout(() => {
      const subDomainJOArray = subDomainJoFull !== undefined ? subDomainJoFull.split(",") : [];

      this.sharedService.topPage();
      if (listData === undefined || listData === null) {
        listData = [];
      }

      listData = this.sharedService.cleanEscapedNewlines(listData);

      subDomainJOArray.forEach((subDomainJoSplitFull) => {
        // console.log("subDomainJoSplitFull : ", subDomainJoSplitFull);
        let subDomainJoSplit = this.sharedService.getEndpoint(subDomainJoSplitFull);
        let fuentePascalCase = this.sharedService.convertSnakeCaseToPascalCase(subDomainJoSplit);
        let columnsVistaPrevia = [];
        let columnsNameData = [];

        if (subDomainJoSplitFull == "DELINQUENCY_BOLAB") {
          listData = listData.sort(
            (a, b) => Number(b.debt_date) - Number(a.debt_date)
          );
        }
        if (this.currentCountry == "py" && subDomainJoFull == "DELINQUENCY_EXCH") {
          if (this.localStorageService.getIsVip) {
            let dataFiltrada = listData.filter(filtro => filtro.tipo_registro === 'I' && (filtro.baja == null || filtro.baja == ""));
            listData = dataFiltrada;
          }
        }

        this.localStorageService.getEstructuraDinamicaField.sort((a: any, b: any) => a.order - b.order).forEach(element => {
          this.dataEstructuraFields(element, listData, columnsVistaPrevia, columnsNameData, 'vistaPrevia');
        });

        const headerConfig = this.localStorageService.dataEstructuraDinamicaHeader;

        // Verificar si el rol es ADDRESS_PHONE_EMAIL en Paraguay para deshabilitar eliminación
        const countryLower = this.currentCountry.toLowerCase();
        const roleUpper = this.localStorageService.getPermissionCountry.roles.toUpperCase();
        const permitAll = this.sharedService.parseRolesArray(this.localStorageService.configInit['F_PERMISSION_ALL_ROLES']);
        const isAddressPhoneEmailPyCase: boolean = countryLower === 'py' && roleUpper === permitAll[4]; // "ADDRESS_PHONE-EMAIL"

        this.divSubDomainJO = []; // Asegúrate de limpiar el array aquí dentro también
        this.divSubDomainJO.push({
          id: subDomainJoSplit,
          pascalCase: fuentePascalCase,
          tituloPagina: headerConfig.title,
          permiteAnadir: headerConfig.add,
          permiteEliminar: headerConfig.delete,
          vistaPrevia: columnsVistaPrevia,
          columnsName: columnsNameData,
          dataVistaPrevia: listData,
          dataVistaPreviaFilter: listData,
          showResultTable: true,
          showVistaDetalle: false,
          addPreview: headerConfig.addPreview,
          deletePreview: isAddressPhoneEmailPyCase ? false : headerConfig.deletePreview,
          bulkEditPreview: headerConfig.bulkEditPreview,
          addPreviewTwo: headerConfig.addPreviewTwo,
          deletePreviewTwo: isAddressPhoneEmailPyCase ? false : headerConfig.deletePreviewTwo,
          bulkEditPreviewTwo: headerConfig.bulkEditPreviewTwo
        });


      });

      // console.log('%cObjeto final para la vista (divSubDomainJO):', 'color: blue; font-weight: bold;', this.divSubDomainJO);

      if (this.localStorageService.esAltaEntidades) {
        this.onActivate({}, this.subDomainJO, true);
        this.localStorageService.onFilterPreview(null);
      }

      if ((this.localStorageService.esInternoRDS || this.localStorageService.getIsExternoRDS) && listData.length === 1) {
        this.onActivate(listData[0], this.subDomainJO, false);
      }

      this.cdr.detectChanges();
    }, 0); // El '0' es importante, hace que se ejecute en el siguiente ciclo.
  }

  /**
   * Construye prop y name del datatable
   * @param viewType 'vistaPrevia' o 'vistaPreviaTwo' para saber qué columnas mostrar.
   */
  dataEstructuraFields(element: any, listData: any[], columnsVistaPrevia: any[], columnsName?, viewType: 'vistaPrevia' | 'vistaPreviaTwo' = 'vistaPrevia') {
    // Ahora la condición usa el parámetro viewType
    if (element[viewType]) {
      if (element.inputType === "select" || element.inputType === "checkbox") {
        // console.log("FuenteDinamicaComponent dataEstructuraFields SI select");
        listData.forEach((fila) => {
          fila[element.name + "_select"] =
            this.sharedService.mostrarDataSelectGFD(
              fila[element.name],
              element.value,
              element.name
            );
        });
        columnsVistaPrevia.push({
          prop: element.name + "_select",
          name: element.label + ".",
        });
      } else {
        // console.log("FuenteDinamicaComponent dataEstructuraFields NO select");
        columnsVistaPrevia.push({
          prop: element.name,
          name: element.label,
        });
      }

      columnsName?.push({
        columVar: element.name,
        columLabel: element.label,
      });
    }
  }

  fillEstructuraDinamicaFields() {
    return true;
  }

  /**
   * Punto de entrada centralizado para la activación de vistas.
   * Decide si cargar la segunda preview o el detalle final.
   */
  onActivate(event: any, subDomainJO: string, add: boolean = false) {
    // console.log('onActivate', event, subDomainJO, add, `currentView: ${this.currentView}`);

    const isVipCreditDefaultUy = add &&
      this.localStorageService.getIsVip &&
      this.currentCountry.toUpperCase() === 'UY' &&
      this.subDomainJO === "CREDIT_DEFAULT";

    if (isVipCreditDefaultUy) {
      // console.log("Caso especial: Añadiendo CREDITO_DEFAULT para VIP en UY. Se cargará estructura y se irá a vista de detalle.");
      this.showLoading = true;

      const profile = this.localStorageService.getBuscadorSelect?.profile;
      const domainAux = profile == "COMMERCIAL"
        ? "CONTRIBUTION.EMP.UY_CREDIT"
        : "CONTRIBUTION.PER.UY_CREDIT";

      this.loadEstructuraParaDetalle("CREDIT_DEFAULT", domainAux).subscribe({
        next: () => {
          // console.log("Estructura cargada. Navegando a la vista de detalle...");
          this.chargeDetail(this.onCreateData(), subDomainJO, true);
          this.showLoading = false;
        },
        error: (err) => {
          console.error("Error al cargar la estructura para la vista de detalle:", err);
          this.notificationService.showError("No se pudo cargar la configuración para añadir el registro.");
          this.showLoading = false;
        }
      });

      return;
    }

    if (add) {
      this.chargeDetail(this.onCreateData(), subDomainJO, true);
      return;
    }

    if (this.multiplePreview && this.currentView === 'preview1') {
      this.chargeSecondPreview(event);
      return;
    }

    this.chargeDetail(event, subDomainJO, false);
  }

  /**
   * Carga los datos para la segunda tabla de previsualización.
   * @param selection El registro seleccionado de la primera tabla.
   */
  async chargeSecondPreview(selection: any) {
    // console.log('Cargando segunda preview para la selección:', selection);
    if (!selection || !selection.matchKey) {
      this.notificationService.showError("El registro seleccionado es inválido o no contiene una matchKey.");
      return;
    }
    const structureHeader = this.localStorageService.dataEstructuraDinamicaHeader;

    // Usar baseUrlTwo del header con fallback al menú
    const baseUrlTwo = structureHeader?.baseUrlTwo || this.menuBaseUrlTwoFallback;

    if (!baseUrlTwo || !structureHeader?.periodsMatchKeyField) {
      const missingConfig = [];
      if (!baseUrlTwo) missingConfig.push('baseUrlTwo');
      if (!structureHeader?.periodsMatchKeyField) missingConfig.push('periodsMatchKeyField');

      console.warn('[chargeSecondPreview] Configuración incompleta:', {
        headerBaseUrlTwo: structureHeader?.baseUrlTwo,
        menuFallback: this.menuBaseUrlTwoFallback,
        finalBaseUrlTwo: baseUrlTwo,
        missingConfig
      });

      this.notificationService.showError("Configuración incompleta para la vista de historial.");
      return;
    }

    console.log('[chargeSecondPreview] Usando baseUrlTwo:', {
      fromHeader: structureHeader?.baseUrlTwo,
      fromMenuFallback: this.menuBaseUrlTwoFallback,
      finalValue: baseUrlTwo,
      usedFallback: !structureHeader?.baseUrlTwo
    });

    this.lastPreview1Selection = selection;
    this.showLoading = true;

    const fullMatchKeyOriginal = selection.matchKey;
    const periodsField = structureHeader.periodsMatchKeyField;

    // Obtener la estructura de la matchkey desde el header
    const matchKeyFromHeader = structureHeader.matchKey;

    // console.log("MATCHKEY FOR SECOND PREVIEW: ", structureHeader.matchKey)

    if (!matchKeyFromHeader) {
      console.warn('No se encontró matchKey en el header. Usando matchKey original.');
      if (this.isTelco) {
        this.loadTelcoThenPreview2(baseUrlTwo, fullMatchKeyOriginal, periodsField, selection);
      } else {
        this.loadPreview2Data(baseUrlTwo, fullMatchKeyOriginal, periodsField);
      }
      return;
    }

    // Convertir el matchKey del header (string) a array
    const sep = structureHeader.separator || '.';
    const matchKeyStructure: string[] = matchKeyFromHeader.split(sep);
    // console.log('Estructura de matchKey desde header:', matchKeyStructure);

    // Encontrar la posición del periodsMatchKeyField en la estructura
    const periodFieldIndex = matchKeyStructure.findIndex(field => field === periodsField);

    if (periodFieldIndex === -1) {
      console.warn(`Campo '${periodsField}' no encontrado en la estructura de matchKey. Usando matchKey original.`);
      if (this.isTelco) {
        this.loadTelcoThenPreview2(baseUrlTwo, fullMatchKeyOriginal, periodsField, selection);
      } else {
        this.loadPreview2Data(baseUrlTwo, fullMatchKeyOriginal, periodsField);
      }
      return;
    }

    // Construir la matchkey usando solo los campos ANTES del periodsMatchKeyField
    const matchKeyParts = fullMatchKeyOriginal.split(sep);
    const matchKeyForPreview2 = matchKeyParts.slice(0, periodFieldIndex).join(sep);

    // console.log(`MatchKey construida para preview 2:`);
    // console.log(`  - Original: ${fullMatchKeyOriginal}`);
    // console.log(`  - Campos a incluir (hasta índice ${periodFieldIndex}):`, matchKeyStructure.slice(0, periodFieldIndex));
    // console.log(`  - Preview 2: ${matchKeyForPreview2}`);

    this.currentHistoryMatchKey = matchKeyForPreview2;

    // Para fuentes TELCO, obtener ult_aporte_fh antes de cargar preview 2
    if (this.isTelco) {
      this.loadTelcoThenPreview2(baseUrlTwo, matchKeyForPreview2, periodsField, selection);
    } else {
      this.loadPreview2Data(baseUrlTwo, matchKeyForPreview2, periodsField);
    }
  }

  /**
   * Carga los datos de la preview 2 usando la matchKey proporcionada.
   */
  private loadPreview2Data(baseUrlTwo: string, matchKey: string, periodsField: string) {
    this.fuenteDinamicaService.getDataFuenteDinamicaList(
      this.subDomainJO,
      this.urlFuente,
      this.currentCountry,
      this.typeSearch,
      this.dominioSubDominioGKL,
      baseUrlTwo,
      false,
      matchKey,
      periodsField,
      true
    ).subscribe({
      next: (response: any) => {
        // console.log('Respuesta recibida (esperando array):', response);
        const listDataRaw: any[] = Array.isArray(response) ? response : [];
        // console.log('Datos CRUDOS asignados (listDataRaw):', listDataRaw);

        if (listDataRaw.length === 0) {
          console.warn('Los datos crudos asignados están VACÍOS.');
        }

        let dataProcessed = listDataRaw.map(row => ({ ...row }));
        let columnsDefPreview2 = [];
        let columnsNamePreview2 = [];
        let fieldsNeedingSelectTransform: EstructuraDinamicaField[] = [];

        try {
          const fieldsForPreview2 = this.localStorageService.getEstructuraDinamicaField
            .filter(field => field.vistaPreviaTwo)
            .sort((a, b) => {
              // La Preview 2 ordena por columnOrderTwo (independiente del columnOrder de la Preview 1)
              const orderA = Number((a as any).columnOrderTwo ?? a.columnOrder ?? a.order ?? Infinity);
              const orderB = Number((b as any).columnOrderTwo ?? b.columnOrder ?? b.order ?? Infinity);
              const numA = isNaN(orderA) ? Infinity : orderA;
              const numB = isNaN(orderB) ? Infinity : orderB;
              return numA - numB;
            });

          fieldsForPreview2.forEach(element => {
            const colName = element.name;
            const colLabel = element.label;
            let propName = colName;
            if (element.inputType === "select" || element.inputType === "checkbox") {
              fieldsNeedingSelectTransform.push(element);
              propName = colName + "_select";
              columnsDefPreview2.push({ prop: propName, name: colLabel + "." });
            } else {
              columnsDefPreview2.push({ prop: propName, name: colLabel });
            }
            columnsNamePreview2.push({ columVar: colName, columLabel: colLabel });
          });
        } catch (e) {
          console.error("Error al procesar la estructura para la segunda preview: ", e);
          return;
        }

        this.columnsVistaPrevia2 = columnsDefPreview2;
        this.columnsNameData2 = columnsNamePreview2;

        if (fieldsNeedingSelectTransform.length > 0) {
          dataProcessed.forEach(fila => {
            fieldsNeedingSelectTransform.forEach(field => {
              const fieldName = field.name;
              const fieldValue = fila[fieldName];
              fila[fieldName + "_select"] = this.sharedService.mostrarDataSelectGFD(
                fieldValue,
                field.value,
                fieldName
              );
            });
          });
        }

        this.dataVistaPrevia2 = [];
        this.dataVistaPreviaFilter2 = [];
        this.unselectItems();
        setTimeout(() => {
          this.dataVistaPrevia2 = dataProcessed;
          this.dataVistaPreviaFilter2 = dataProcessed;
          this.showLoading = false;
          this.currentView = 'preview2';
        }, 0);

      },
      error: (err) => {
        console.error('Error al cargar datos para la segunda preview:', err);
        this.notificationService.showError('No se pudieron cargar los detalles del historial.');
        this.unselectItems();
        this.showLoading = false;
      }
    });
  }

  /**
   * Refactorización de la lógica para mostrar la vista de detalle.
   */
  chargeDetail(eventData: any, subDomainJO: string, isAdding: boolean) {
    if (isAdding) {
      this.addingObservatoin = true;
      this.onFuenteDinamicaSelected(eventData, subDomainJO);
      this.currentView = 'detail';
      this.cdr.detectChanges();
      afterNextRender(() => {
        this.fuenteDinamicaDetail?.onEdit();
        this.cdr.detectChanges();
      }, { injector: this.injector });
    } else {
      this.addingObservatoin = false;
      this.onFuenteDinamicaSelected(eventData, subDomainJO);
      this.currentView = 'detail';
      this.cdr.detectChanges();
      afterNextRender(() => {
        this.cdr.detectChanges();
      }, { injector: this.injector });
    }
  }

  /**
   * Maneja la navegación hacia atrás entre las vistas.
   * Si se está editando en la vista de detalle, muestra el modal cancelEdit antes de navegar.
   */
  handleBackButton(): void {
    if (this.currentView === 'detail' && this.isEditing) {
      this.confirmationDialogService.cancelEdit()
        .then((confirmed) => {
          if (confirmed) {
            // Resetear el formulario del detail antes de navegar
            if (this.fuenteDinamicaDetail) {
              this.fuenteDinamicaDetail.initStructDinamy();
              this.fuenteDinamicaDetail.isEditing = false;
              this.fuenteDinamicaDetail.emitIsEditing.emit(false);
            }
            this.navigateBack();
          }
        })
        .catch(() => {
          console.error('[handleBackButton] Error en modal de cancelar edición');
        });
    } else {
      // Si no se está editando, navegar directamente
      this.navigateBack();
    }
  }

  /**
   * Ejecuta la navegación hacia atrás según la vista actual.
   */
  protected navigateBack(): void {
    setTimeout(() => {
      this.isEditing = false;
      this.addingObservatoin = false;

      if (this.currentView === 'detail') {
        this.currentView = this.multiplePreview ? 'preview2' : 'preview1';
        this.unselectItems();
      } else if (this.currentView === 'preview2') {
        this.currentView = 'preview1';
        this.lastPreview1Selection = null;
        this.dataVistaPrevia2 = [];
        this.dataVistaPreviaFilter2 = [];
        this.unselectItems();
      } else if (this.currentView === 'preview1') {
        this.goToFuentesPage();
      }

      this.cdr.detectChanges();
    });
  }

  onFuenteDinamicaSelected(row: any, subDomainJO: string) {
    // console.log('onFuenteDinamicaSelected', row, subDomainJO);
    if (this.localStorageService.esInternoRDS || this.localStorageService.getIsExternoRDS) {
      // Construir el valor de la primary key compuesta
      let primaryKeyValue = "";

      if (this.primaryKeyFieldsRDS.length > 0) {
        // Si hay campos individuales, construir la primary key compuesta
        const pkValues = this.primaryKeyFieldsRDS.map(field => {
          const value = row[field];
          return value !== null && value !== undefined ? value : "";
        });
        primaryKeyValue = pkValues.join(this.primaryKeySeparatorRDS);
      } else {
        // Fallback: intentar obtener el valor directamente (para compatibilidad)
        primaryKeyValue = row[this.primaryKeyFieldRdsVistaFD] ? row[this.primaryKeyFieldRdsVistaFD] : "";
      }

      this.localStorageService.setPrimarykeyRds = primaryKeyValue;
    }

    this.fuenteDinamicaSelected = row;

    // Verificar si el rol es ADDRESS_PHONE_EMAIL en Paraguay para deshabilitar edición
    const countryLower = this.currentCountry.toLowerCase();
    const roleUpper = this.localStorageService.getPermissionCountry.roles.toUpperCase();
    const permitAll = this.sharedService.parseRolesArray(this.localStorageService.configInit['F_PERMISSION_ALL_ROLES']);
    const isAddressPhoneEmailPyCase: boolean = countryLower === 'py' && roleUpper === permitAll[4]; // "ADDRESS_PHONE-EMAIL"

    this.editionMode = !isAddressPhoneEmailPyCase;

    this.divSubDomainJO.forEach((divSubDomainJOValue) => {
      divSubDomainJOValue.showResultTable = false;
      divSubDomainJOValue.showVistaDetalle = true;
      if (subDomainJO === divSubDomainJOValue.id) {
        divSubDomainJOValue.showVistaDetalle = true;
      }
    });
  }
  updateFilter(subDomainJO: string) {
    // console.log("FuenteDinamicaComponent updateFilter");
    // console.log(subDomainJO);
    this.divSubDomainJO.forEach((divSubDomainJOValue) => {
      if (subDomainJO === divSubDomainJOValue.id) {
        divSubDomainJOValue.dataVistaPreviaFilter =
          this.sharedService.applyTableFilters(
            divSubDomainJOValue.dataVistaPrevia,
            this.filters
          );
      }
    });
  }


  removeFilter(subDomainJO: string) {
    // console.log("FuenteDinamicaComponent removeFilter");
    // console.log(subDomainJO);
    this.filters.forEach((filter) => (filter.nativeElement.value = ""));
    this.divSubDomainJO.forEach((divSubDomainJOValue) => {
      if (subDomainJO === divSubDomainJOValue.id) {
        divSubDomainJOValue.dataVistaPreviaFilter =
          divSubDomainJOValue.dataVistaPrevia;
      }
    });
  }

  addNewFuenteDinamica() {
    this.editionMode = false;
  }

  deleteFuenteDinamica(subDomainJO: string) {
    this.confirmationDialogService
      .confirmDelete()
      .then((confirmed) => {
        if (confirmed) {
          let matchArray: string[] = [];

          // console.log("this.selected ---->", this.selected);
          this.selected.forEach(item => {
            if (item.hasOwnProperty('matchKey')) {
              matchArray.push(item.matchKey);
            }
          });

          const optionSelected = this.selected.map(item => {
            if (item.hasOwnProperty('matchKey')) {
              let matchKey = this.fuentesManuales.periods && this.fuentesManuales.periodsType === "date"
                ? item.matchKey.slice(0, -8) :
                item.matchKey;
              return { ...item, matchKey: matchKey }
            }
            return item;
          })
          // todo: revisar
          // this.selected = optionSelected;

          let matchKeySelected = matchArray.map(matchKey => {
            let value = this.fuentesManuales.periods && this.fuentesManuales.periodsType === "date" ? matchKey.slice(0, -8) : matchKey;
            return {
              field: 'matchKey',
              value
            };
          });

          // OPTIMIZACIÓN: Solo obtener los matchKey fields si hay 2+ registros
          // Con 1 registro se usa el matchKey completo sin necesidad de calcular segmentos comunes
          if (this.selected.length > 1) {
            // Obtener fields del matchKey para cálculo robusto de segmentos comunes
            this.fuenteDinamicaService.getMatchKey(
              this.currentCountry.toUpperCase(),
              this.domain,
              this.subdomain
            ).subscribe({
              next: (response: any) => {
                // Extraer fields y separador de la respuesta
                const fields = response?.fields || [];
                const separator = response?.separador || response?.separator || '.';

                // Ejecutar delete con los fields obtenidos
                this.executeSoftDelete(subDomainJO, fields, separator);
              },
              error: (err) => {
                console.error('[FuenteDinamicaComponent] Error al obtener matchKey fields, usando método legacy:', err);
                // Si falla, ejecutar sin fields (usará método legacy con split)
                this.executeSoftDelete(subDomainJO);
              }
            });
          } else {
            // Con 1 solo registro, no necesitamos los fields
            this.executeSoftDelete(subDomainJO);
          }
        }
      })
      .catch(() =>
        console.error("error en modal de borrar Exchange Crédito Cerrado")
      );
  }

  /**
   * Ejecuta la operación de soft delete con los parámetros proporcionados
   * @param subDomainJO - Subdominio
   * @param matchKeyFields - Opcional: campos del matchKey para cálculo robusto
   * @param separator - Opcional: separador del matchKey
   */
  private executeSoftDelete(subDomainJO: string, matchKeyFields?: string[], separator: string = '.') {
    this.fuenteDinamicaService.deleteFuenteDinamicaSource(
      this.dominioSubDominioGKL,
      this.selected,
      this.currentCountry,
      matchKeyFields,
      separator
    ).subscribe((_data: any) => {
      this.openDeleteComplete(subDomainJO);
    }, (_error: any) => {
      console.error('Error al eliminar los registros:', _error);
      this.notificationService.showError('No se pudieron eliminar los registros seleccionados.');
    });
  }

  onSelect({ selected }) {
    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);
  }

  openDeleteComplete(_subDomainJO: string) {
    this.unselectItems();
    this.dialog.closeAll();
    this.notificationService
      .showSuccess(
        "¡Se solicitó correctamente la eliminación de los registros seleccionados!"
      )
      .afterOpened()
      .subscribe(() => {
        const options = {
          positionContainer: 'center',
          icon: 'check_circle',
          iconColor: 'success',
          iconSize: '64px',
          buttonActive: true,
          buttonSecondaryActive: false,
          buttonPrimary: 'Aceptar',
          buttonSecondary: 'Cancelar',
        }
        this.confirmationDialogService
          .confirmActionGeneral('La operación fue solicitada exitosamente', 'Los resultados se verán reflejados durante el trnascurso del día', options)
          .then((confirmed) => {
            if (confirmed) { this.refreshGridAfterUpdate(); }
          })
      });
  }

  unselectItems() {
    this.selected = [];

    // Limpiar selección en preview1 (tabla principal)
    if (this.listTable && this.listTable.clearSelection) {
      this.listTable.clearSelection();
    }

    // Limpiar selección en preview2 (tabla de historial/periodos)
    if (this.listTable2 && this.listTable2.clearSelection) {
      this.listTable2.clearSelection();
    }
  }

  onCancel() {
    this.addingObservatoin = false;
  }

  /**
   * Metodo que se ejecuta luego de rotornar a la la vista preview, desde la vista detalle
   */
  onReturnToList(_$subDomainJO) {
    // El detalle ya resolvió su flujo (DIS, contribution, etc.);
    // navegar directamente sin disparar el modal de descarte.
    this.navigateBack();

    // if (this.multiplePreview) {
    //   this.handleBackButton();
    //   return;
    // }
    //
    // if (this.fuentesManuales.periods && this.fuentesManuales.subDomainsManuals) {
    //   const { periods, subDomainsManuals } = this.fuentesManuales;
    //   this.callAllsSubDomains(subDomainsManuals, periods, false);
    // } else {
    //   this.divSubDomainJO.forEach((divSubDomainJOValue) => {
    //     divSubDomainJOValue.showResultTable = true;
    //     divSubDomainJOValue.showVistaDetalle = false;
    //     divSubDomainJOValue.dataVistaPreviaFilter = divSubDomainJOValue.dataVistaPrevia;
    //   });
    // }
  }

  /**
   * Método que se ejecuta luego de editar por DIS para recargar la vista previa
   */
  onReturnReloadList(eventReloadList) {
    setTimeout(() => {
      this.showLoading = true;
      // Limpiar selección después de cualquier edición
      this.unselectItems();

      if (this.multiplePreview && this.lastPreview1Selection) {
        this.chargeSecondPreview(this.lastPreview1Selection);
        //this.currentView = 'preview2';
        this.divSubDomainJO.forEach(d => d.showVistaDetalle = false);
        return;
      }

      //this.localStorageService.setMatchKeyData = null;
      // console.log("FuenteDinamicaComponent onReturnReloadList", eventReloadList);
      let subDomainJO = eventReloadList.subDomainJO;
      let currentMatchKeyOld = eventReloadList.currentMatchKeyOld;
      let currentMatchKeyNew = eventReloadList.currentMatchKeyNew;
      let currentCountry = eventReloadList.currentCountry;

      this.successDIS = true;
      this.viewSoftDeleted = false;
      let route = this.obtenerFuenteDesdeRuta();
      // console.log('this.idHashDataAdded2', this.idHashDataAdded);
      const periodsField = this.localStorageService.dataEstructuraDinamicaHeader?.periodsMatchKeyField;

      if (this.localStorageService.subdomainPurp !== '') {
        const baseURL = this.baseUrlfuente || "";
        const country = this.currentCountry || "";
        const header = this.localStorageService.dataEstructuraDinamicaHeader;

        const subDomainPurp = header?.subdomainPurp || "";
        const entityKey = this.localStorageService.getPersonaSelected.entityKey;

        console.log('[onReturnReloadList] Recargando con servicio PURP:', {
          baseURL,
          subDomainPurp,
          domain: this.domain,
          subdomain: this.subdomain
        });

        this.fuenteDinamicaService.getPurposing(baseURL, country, this.domain, subDomainPurp, entityKey, this.subdomain).subscribe({
          next: (listData: any) => {
            if (listData && listData.hasOwnProperty('payload')) {
              let data = listData.payload[this.subdomain] || [];
              this.reload(data, subDomainJO, currentCountry, currentMatchKeyOld, currentMatchKeyNew);
            }else{
              console.error('[hasOwnProperty] Respuesta de PURP sin payload esperado:', listData);
            }
          },
          error: _error => {

            this.showLoading = true; // quitar loading en caso que falle
          }
        });
      } else {
        this.fuenteDinamicaService.getDataFuenteDinamicaList(
          subDomainJO,
          route,
          this.currentCountry,
          this.typeSearch,
          this.dominioSubDominioGKL,
          this.baseUrlfuente,
          false,
          this.idHashDataAdded,
          periodsField,
          false
        ).subscribe({
          next: (listData: any[]) => {
            this.sharedService.topPage();
            this.reload(listData, subDomainJO, currentCountry, currentMatchKeyOld, currentMatchKeyNew);
          },
          error: _error => {
            console.error("Error al recargar la lista después de DIS:", _error);
            this.showLoading = true; // quitar loading en caso que falle
          }
        }
        );
      }

      this.cdr.detectChanges();
    });
  }

  //// funcion agregada 1 fuentes manuales ////
  createList(list, manualVariants) {

    let rows = [];

    const variants = manualVariants;
    for (const key in list) {

      let currentType = list[key];
      let option: any = this.getOption(key, variants);

      currentType.forEach(element => {
        let newRow = element;
        newRow.tipo = key;
        newRow.producto = option.title;
        newRow.option = option;
        rows.push(newRow)
      });
    }

    // console.log("row --->", rows);
    return rows;
  }

  //// funcion agregada 1 fuentes manuales ////
  getOption(key: string, variants: any) {

    const { method } = variants;
    let option
    method.forEach(m => {
      let include = m.type.includes(key);
      if (include) {
        option = m;
      }
    })

    return option;
  }
  /// button add  manuals//
  statusButton(event) {
    this.disabledAddButton = event.add;
    this.disabledEditButton = event.edit;
  }

  callAllsSubDomains(subDomainsManuals, periods, type) {
    const { domainJO } = this.fuentesManuales;
    // console.log("callAllsSubDomains domainJO --->", domainJO);
    //this.localStorageService.setMatchKeyData = null;
    const observables = subDomainsManuals.map(subDomain => {
      this.dominioSubDominioGKL = `${domainJO}/${subDomain}`;
      // console.log("observables this.dominioSubDominioGKL ---->", this.dominioSubDominioGKL);
      return this.fuenteDinamicaService
        .getDataFuenteDinamicaList(
          subDomain,
          this.urlFuente,
          this.currentCountry,
          this.typeSearch,
          this.dominioSubDominioGKL,
          this.baseUrlfuente,
          periods,
          '',
          null,
          false
        )
    });

    forkJoin(observables).subscribe({
      next: (response: any) => {
        let listData: any = [];
        // console.log("callAllsSubDomains response ----->", response);

        const list = this.transformArrayToObject(response);
        // console.log("callAllsSubDomains list ------->", list)
        this.sharedService.topPage();

        // console.log("callAllsSubDomains listData----->", listData);

        if (listData === undefined) {
          listData = [];
        }

        listData = this.createList(list, this.fuentesManuales.manualVariants);

        // console.log("callAllsSubDomains resListData ------>", listData);

        let columnsVistaPrevia = [];
        let columnsNameData = [];

        columnsNameData = this.fuentesManuales.manualVariants.columDataTable;
        if (type) {
          const fuentePascalCase = this.sharedService.convertSnakeCaseToPascalCase(domainJO);
          this.generateDataTable(domainJO, fuentePascalCase, columnsVistaPrevia, columnsNameData, listData);
        } else {
          this.divSubDomainJO.forEach((divSubDomainJOValue) => {
            divSubDomainJOValue.showResultTable = true;
            divSubDomainJOValue.showVistaDetalle = false;
            divSubDomainJOValue.dataVistaPreviaFilter = listData;
          });
        }
      }
    })
  }

  transformArrayToObject(items: Array<any>) {
    const result = {};
    items.forEach(item => {
      if (typeof item === 'object' && item !== null) {
        Object.keys(item).forEach(key => {

          if (result[key]) {
            result[key] = result[key].concat(item[key]);
          } else {
            result[key] = item[key];
          }
        })
      }
    })
    return result;
  }

  setSubtitle(event: string) {
    this.subTitle = event;
  }

  generateDataTable(subDomainJoSplit: string, fuentePascalCase: string, columnsVistaPrevia: any, columnsNameData: any, listData: any) {
    const headerConfig = this.localStorageService.dataEstructuraDinamicaHeader;

    // Verificar si el rol es ADDRESS_PHONE_EMAIL en Paraguay para deshabilitar eliminación
    const countryLower = this.currentCountry.toLowerCase();
    const roleUpper = this.localStorageService.getPermissionCountry.roles.toUpperCase();
    const permitAll = this.sharedService.parseRolesArray(this.localStorageService.configInit['F_PERMISSION_ALL_ROLES']);
    const isAddressPhoneEmailPyCase: boolean = countryLower === 'py' && roleUpper === permitAll[4]; // "ADDRESS_PHONE-EMAIL"

    this.divSubDomainJO = [];
    this.divSubDomainJO.push({
      id: subDomainJoSplit,
      pascalCase: fuentePascalCase,
      tituloPagina: headerConfig.title,
      permiteAnadir: headerConfig.add,
      permiteEliminar: headerConfig.delete,
      vistaPrevia: columnsVistaPrevia,
      columnsName: columnsNameData,
      dataVistaPrevia: listData,
      dataVistaPreviaFilter: listData,
      showResultTable: true,
      showVistaDetalle: false,
      addPreview: headerConfig.addPreview,
      deletePreview: isAddressPhoneEmailPyCase ? false : headerConfig.deletePreview,
      bulkEditPreview: headerConfig.bulkEditPreview,
      addPreviewTwo: headerConfig.addPreviewTwo,
      deletePreviewTwo: isAddressPhoneEmailPyCase ? false : headerConfig.deletePreviewTwo,
      bulkEditPreviewTwo: headerConfig.bulkEditPreviewTwo
    });
  }

  // TELCO ////////////////////////////////////////////////////////

  /**
   * Para fuentes TELCO, obtiene ult_aporte_fh antes de cargar preview 2.
   * El valor se pasa al componente de tabla para colorear filas.
   */
  private loadTelcoThenPreview2(baseUrlTwo: string, matchKey: string, periodsField: string, selection: any) {
    const adhMatrizCod = selection?.adh_matriz_cod || selection?.clave_aporte || '';
    if (!adhMatrizCod) {
      console.warn('[loadTelcoThenPreview2] No se encontró adh_matriz_cod en la selección, cargando sin telco');
      this.loadPreview2Data(baseUrlTwo, matchKey, periodsField);
      return;
    }

    this.fuenteDinamicaTelcoService.fillVistaPreviaTelco(
      adhMatrizCod.toUpperCase(),
      this.currentCountry,
      '/api/v4/sources/'
    ).then(data => {
      const letSources = Object.keys(data['payload'])[0];
      if (letSources) {
        const { ultAporteFhTelco } = this.fuenteDinamicaTelcoService.promiseTelcoService(data, letSources, adhMatrizCod);
        this.ultAporteFhTelco = ultAporteFhTelco;
      }
      this.loadPreview2Data(baseUrlTwo, matchKey, periodsField);
    }).catch(_error => {
      console.error('[loadTelcoThenPreview2] Error al obtener ult_aporte_fh:', _error);
      this.ultAporteFhTelco = 0;
      this.loadPreview2Data(baseUrlTwo, matchKey, periodsField);
    });
  }

  // RDS ////////////////////////////////////////////////////////

  onDataPrimarykeyRdsChange(datoPrimarykey: any) {
    const { data, type } = datoPrimarykey;

    this.localStorageService.setPrimarykeyRds = data || datoPrimarykey;
    if (type === 'primarykey') {
      this.traeDataPreview(this.localStorageService.getSourceSubDomainSelected);
    } else {
      const { type } = datoPrimarykey;

      const body =
      {
        "alternateKey": {
          "keyName": type,
          "keyValues": [data]
        }
      }

      console.log(`Cambio en campo de alternaty key: ${type} con valor: ${data}`);

      this.fuenteDinamicaService.callRDS(this.localStorageService.getSourceSubDomainSelected, body, this.baseUrlfuente, this.currentCountry).subscribe({
        next: (listaData: any) => {
          console.log(`Respuesta de RDS para ${type}:`, listaData);
          const response = listaData;
          this.avanzarPreview(response, this.localStorageService.getSourceSubDomainSelected);
          console.log('Respuesta de RDS para campo alternaty key:', response);
          this.notificationService.showSuccess(`Valor de RDS obtenido para ${type}: ${response}`);
          // Aquí podrías actualizar la vista previa con el nuevo valor si es necesario
        }
        , error: (err) => {
          console.error(`Error al obtener valor de RDS para ${type}:`, err);
          this.avanzarPreview([], this.subDomainJO);
        }
      })
    }

  }

  onFunctions(event) {
    console.log("Evento recibido en onFunctions:", event);
  }

  // Masiva ////////////////////////////////////////////////////////
  async onEdicionMasiva(): Promise<void> {
    if (this.selected?.length > 100) {
      this.notificationService.showError('La operación que desea realizar excede el limite máximo permitido.');
      return;
    }

    const IS_TRADE_SOURCE = (this.domain === 'DO_CREDIT' && this.subDomainJO === 'TRADE');
    const IS_BCRA_SOURCE = (this.domain === 'AR_CREDIT' && this.subDomainJO === 'BCRA_FINANCIAL_STATUS');
    const IS_SICOM_OR_MICROFINANCE = this.localStorageService.getIsVip && this.domain === 'EC_CREDIT' &&
      (this.subDomainJO === 'SICOM_SUMMARY' || this.subDomainJO === 'MICROFINANCE');

    await this.ensureAvroSchemaLoaded();

    // Forzar detección de cambios antes de abrir modales
    this.cdr.detectChanges();

    if (IS_TRADE_SOURCE) {
      try {
        await this.tradeService.showTradeMassiveEdit(
          this.currentView,
          this.selected,
          this.currentHistoryMatchKey,
          this.lastPreview1Selection,
          (selection) => this.chargeSecondPreview(selection),
          this.avroSchema,
        );
      } catch (error) {
        console.error('[onEdicionMasiva] Error en Trade modal:', error);
      }
    } else if (IS_BCRA_SOURCE) {
      console.log('[onEdicionMasiva] Delegando edición masiva de BCRA al servicio...');
      try {
        await this.bcraService.showBcraMassiveEdit(
          this.currentView,
          this.dataVistaPrevia2, // Todos los períodos disponibles
          this.currentHistoryMatchKey,
          this.lastPreview1Selection,
          (selection) => this.chargeSecondPreview(selection),
          this.avroSchema,
        );
        console.log('[onEdicionMasiva] BCRA modal procesado');
      } catch (error) {
        console.error('[onEdicionMasiva] Error en BCRA modal:', error);
      }
    } else if (IS_SICOM_OR_MICROFINANCE) {
      console.log('[onEdicionMasiva] Activando menú de eliminación masiva para SICOM/MICROFINANCE');
      this.showEliminacionMasivaSicomMicro = true;
    } else {
      console.log('[onEdicionMasiva] Iniciando lógica de edición masiva GENÉRICA');
      this.showEliminacionMasiva = true;
    }

    // Forzar detección de cambios después de procesar
    this.cdr.detectChanges();
  }

  private getSortedEstructuraFields(): EstructuraDinamicaField[] {
    const itemsToCompare = this.localStorageService.getEstructuraDinamicaField
      .map((fieldInstance, index) => ({
        instance: fieldInstance,
        originalIndex: index,
      }));

    const parseOrderValue = (value: string | null | undefined): number | null => {
      if (value === null || value === undefined) {
        return null;
      }
      if (typeof value === 'string' && value.trim() === "") {
        return null;
      }
      const num = parseFloat(value as string);
      return isNaN(num) ? null : num;
    };

    itemsToCompare.sort((a, b) => {
      const numColumnOrderA = parseOrderValue(a.instance.columnOrder);
      const numColumnOrderB = parseOrderValue(b.instance.columnOrder);

      const aHasValidColumnOrder = numColumnOrderA !== null;
      const bHasValidColumnOrder = numColumnOrderB !== null;

      if (aHasValidColumnOrder && bHasValidColumnOrder) {
        if (numColumnOrderA !== numColumnOrderB) {
          return (numColumnOrderA as number) - (numColumnOrderB as number);
        }
      } else if (aHasValidColumnOrder) {
        return -1;
      } else if (bHasValidColumnOrder) {
        return 1;
      }

      const numOrderA = parseOrderValue(a.instance.order);
      const numOrderB = parseOrderValue(b.instance.order);

      const aHasValidOrder = numOrderA !== null;
      const bHasValidOrder = numOrderB !== null;

      if (aHasValidOrder && bHasValidOrder) {
        if (numOrderA !== numOrderB) {
          return (numOrderA as number) - (numOrderB as number);
        }
      } else if (aHasValidOrder) {
        return -1;
      } else if (bHasValidOrder) {
        return 1;
      }

      return a.originalIndex - b.originalIndex;
    });

    return itemsToCompare.map(item => item.instance);
  }

  getRdsDataByCollection() {
    this.fuenteDinamicaService
      .getRdsDataByCollection(this.localStorageService.getSourceSubDomainSelected)
      .subscribe({
        next: (json) => {
          const transformApiResponse = this.transformApiResponse(json);
          this.avanzarPreview(transformApiResponse.response, this.localStorageService.getSourceSubDomainSelected)
          this.notificationAlertService.show({
            title: '¡Datos RDS obtenidos y procesados exitosamente!',
            type: 'success',
            mode: 'component',
            position: 'top-right',
            color: '#fff',
            maxWidth: '960px'
          });
        },
        error: (error) => {
          this.notificationAlertService.show({
            title: `Error al obtener datos RDS: ${error.message || 'Ha ocurrido un error desconocido.'}`,
            type: 'error',
            mode: 'component',
            position: 'top-right',
            color: '#fff',
            maxWidth: '960px'
          });
        }
      });
  }

  // >>> INICIO: Métodos de Eliminación Masiva para SICOM_SUMMARY y MICROFINANCE <<<

  /**
   * Método genérico para procesar eliminaciones masivas.
   * Valida la selección y delega a la confirmación.
   */
  private processEliminacion(title: string, eliminationType: string): void {
    if (this.selected.length === 0) {
      this.notificationService.showInfo(`Por favor, seleccione al menos un registro para ${title.toLowerCase()}.`);
      return;
    }
    this.showMassiveEliminationConfirmation(title, eliminationType);
  }

  saveEliminacionSuplantacionIdentidad(): void {
    this.processEliminacion(
      'la eliminación por suplantación de identidad',
      'SuplantacionIdentidad'
    );
  }

  saveEliminacionCancelacionPagoCarteraVencidaAlDia(): void {
    this.processEliminacion(
      'Cancelación o Pago - Cartera Vencida y al Día',
      'CancelacionPagoCarteraVencidaAlDia'
    );
  }

  saveEliminacionCancelacionPagoCarteraSoloVencida(): void {
    this.processEliminacion(
      'Cancelación o Pago - Cartera Sólo Vencida',
      'CancelacionPagoCarteraSoloVencida'
    );
  }

  saveEliminacionProveedorPeriodoActualCarteraVencidaAlDia(): void {
    this.processEliminacion(
      'Solicitado por Proveedor (Período Actual - Vencida y al Día)',
      'ProveedorPeriodoActualCarteraVencidaAlDia'
    );
  }

  saveEliminacionProveedorPeriodoActualCarteraSoloVencida(): void {
    this.processEliminacion(
      'Solicitado por Proveedor (Período Actual - Sólo Vencida)',
      'ProveedorPeriodoActualCarteraSoloVencida'
    );
  }

  saveEliminacionProveedorPeriodoHistoricoCarteraVencidaAlDia(): void {
    this.processEliminacion(
      'Solicitado por Proveedor (Período Histórico - Vencida y al Día)',
      'ProveedorPeriodoHistoricoCarteraVencidaAlDia'
    );
  }

  saveEliminacionProveedorPeriodoHistoricoCarteraSoloVencida(): void {
    this.processEliminacion(
      'Solicitado por Proveedor (Período Histórico - Sólo Vencida)',
      'ProveedorPeriodoHistoricoCarteraSoloVencida'
    );
  }

  saveEliminacionProveedorPeriodoFechaDesdeCarteraVencidaAlDia(): void {
    this.processEliminacion(
      'Solicitado por Proveedor (Fecha Desde - Vencida y al Día)',
      'ProveedorPeriodoFechaDesdeCarteraVencidaAlDia'
    );
  }

  saveEliminacionProveedorPeriodoFechaDesdeCarteraSoloVencida(): void {
    this.processEliminacion(
      'Solicitado por Proveedor (Fecha Desde - Sólo Vencida)',
      'ProveedorPeriodoFechaDesdeCarteraSoloVencida'
    );
  }

  private showMassiveEliminationConfirmation(title: string, eliminationType: string): void {
    const mensajeConfirmacion = `¿Desea aplicar la eliminación de ${title} a los ${this.selected.length} registros seleccionados?`;

    this.confirmationDialogService.confirm('Eliminación Masiva', mensajeConfirmacion)
      .then(confirmed => {
        if (confirmed) {
          this.saveEliminacionMasivaSicomMicro(this.selected, eliminationType);
        }
      });
  }

  saveEliminacionMasivaSicomMicro(itemsToUpdate: any[], eliminationType: string): void {
    this.showLoading = true;

    // Determinar qué filas usar según la vista actual
    let totalRows: any[] = [];
    if (this.currentView === 'preview2') {
      totalRows = this.dataVistaPrevia2;
    } else if (this.currentView === 'preview1') {
      // Usa las filas del primer preview del subdomain actual
      const currentSubDomain = this.divSubDomainJO.find(div => div.id === this.subDomainJO);
      totalRows = currentSubDomain?.dataVistaPrevia || [];
    }

    // Calcula si la selección es total
    const isMassiveSelection = itemsToUpdate.length === totalRows.length && totalRows.length > 0;

    // Validar subdomain soportado
    if (
      !(this.domain === 'EC_CREDIT' &&
        (this.subDomainJO === 'SICOM_SUMMARY' || this.subDomainJO === 'MICROFINANCE')
      )
    ) {
      this.showLoading = false;
      this.notificationService.showError('Subdomain no soportado para eliminación masiva.');
      return;
    }

    // Generar payload directamente con el servicio compartido (ahora async con modal integrado)
    this.eliminationPayloadService.generateEliminationPayload(
      itemsToUpdate,
      eliminationType,
      isMassiveSelection
    ).then(async itemsWithEliminationData => {
      // Verificar si el usuario canceló (retorna null)
      if (itemsWithEliminationData === null) {
        this.showLoading = false;
        this.notificationService.showInfo('Operación cancelada por el usuario.');
        return;
      }

      // Empaquetar en el formato DIS
      const payload = { data: itemsWithEliminationData.map(item => JSON.stringify(item)) };

      await this.ensureAvroSchemaLoaded();
      const formattedData = this.doublePreviewService.dataToSaveDISfromDataviewPreview(payload, this.avroSchema);
      const auditData = this.auditService.buildAuditForMassiveSicomMicro(
        // En masiva, pasar array de matchkeys de los seleccionados en lugar de un solo matchkey
        this.selected[0],
        // currentHistoryMatchKey -> si hay selección múltiple usamos el array de matchkeys
        (this.selected && this.selected.length > 1) ? this.selected.map((s: any) => s.matchKey || s.matchkey || s.entityKey || '') : this.currentHistoryMatchKey,
        this.subDomainJO
      );
      let salidareturn = { data: formattedData, audit: auditData };

      if (formattedData.length > 0) {
        const domainPath = `${this.domain}/${this.subDomainJO}`;

        // Usar el servicio compartido EcDisService directamente
        this.ecDisService.postDisPayloadEC(domainPath, salidareturn, this.subDomainJO).subscribe({
          next: (res) => {
            this.notificationService.showSuccess(`La solicitud de eliminación masiva (${eliminationType}) se solicitó correctamente.`);
            this.localStorageService.setMatchkeySelected = this.currentHistoryMatchKey;

            // Recargar según la vista actual
            if (this.currentView === 'preview2' && this.lastPreview1Selection) {
              // Recargar Preview 2
              this.chargeSecondPreview(this.lastPreview1Selection);
            } else {
              // Recargar Preview 1
              this.refreshGridAfterUpdate();
            }

            this.showLoading = false;
          },
          error: (err) => {
            this.showLoading = false;
            this.notificationService.showError('Ocurrió un error en la eliminación masiva.');
            console.error(err);
          }
        });
      } else {
        this.showLoading = false;
      }
    }).catch(error => {
      this.showLoading = false;
      this.notificationService.showError('Error al generar el payload de eliminación.');
      console.error(error);
    });
  }

  // >>> FIN: Métodos de Eliminación Masiva para SICOM_SUMMARY y MICROFINANCE <<<

  transformApiResponse(apiResponse: any): { response: any[] } {
    if (apiResponse && Array.isArray(apiResponse.data)) {
      return {
        response: apiResponse.data.map((item: any) => item.values)
      };
    } else {
      return { response: [] };
    }
  }

  async handleMassUpdateRequest(eventFromModal: any) {
    if (!this.selected || this.selected.length === 0) {
      this.notificationService.showError('No hay registros seleccionados para actualizar.');
      return;
    }

    // Soportar tanto el formato nuevo { fieldsToUpdate, comentarioAudit } como el formato array legacy
    let fieldsToUpdateFromModal: any[];
    let comentarioAudit: string;
    if (Array.isArray(eventFromModal)) {
      fieldsToUpdateFromModal = eventFromModal;
      comentarioAudit = 'Edición Masiva';
    } else {
      fieldsToUpdateFromModal = eventFromModal.fieldsToUpdate;
      comentarioAudit = eventFromModal.comentarioAudit?.trim() || 'Edición Masiva';
    }

    const updatesObject = fieldsToUpdateFromModal.reduce((acc, field) => {
      acc[field.fieldToChange] = field.newValue;
      return acc;
    }, {});

    // Construir array de matchkeys desde this.selected
    const matchKeys = (this.selected || []).map((s: any) => s.matchKey || s.matchkey || s.entityKey || '').filter((v: string) => v);

    // Si es masivo (más de uno seleccionado) o proviene de una función, pasar el array; sino pasar un solo matchkey (o currentHistoryMatchKey si no existe)
    const auditObj = (this.selected && this.selected.length > 1) || this.function
      ? this.auditService.buildAuditForMassiveDis(comentarioAudit, updatesObject, matchKeys)
      : this.auditService.buildAuditForMassiveDis(comentarioAudit, updatesObject, matchKeys[0] || this.currentHistoryMatchKey);

    const payloadForService = {
      selectedItems: this.selected,
      fieldsToUpdate: updatesObject,
      audit: auditObj,
      header: this.localStorageService.dataEstructuraDinamicaHeader,
    };

    const viewBeforeUpdate = this.currentView;
    this.showLoading = true;

    try {
      const observable = await this.fuenteDinamicaService.massiveUpdateDis(payloadForService);
      observable.subscribe({
        next: (response) => {
          this.showLoading = false;
          this.notificationAlertService.show({
            title: 'Se guardó su edición masiva con Éxito!',
            type: 'success',
            mode: 'component',
            position: 'top-right',
            color: '#fff',
            maxWidth: '960px'
          });
          this.showEliminacionMasiva = false;
          this.refreshPertinentPreviewsAfterUpdate(viewBeforeUpdate);
        },
        error: (err) => {
          this.showLoading = false;
          console.error("Falló la edición masiva:", err);
          this.notificationService.showError(err.error?.message || 'Ocurrió un error al procesar la solicitud.');
        }
      });
    } catch (err) {
      this.showLoading = false;
      console.error("Error al preparar la edición masiva:", err);
      this.notificationService.showError('Ocurrió un error al preparar la solicitud.');
    }
  }

  refreshGridAfterUpdate() {
    this.unselectItems(); // Limpia la selección y resetea el estado del datatable (checkbox header)
    this.traeDataPreview(this.subDomainJO);
  }

  private refreshPertinentPreviewsAfterUpdate(viewBeforeUpdate: 'preview1' | 'preview2' | 'detail'): void {

    this.unselectItems();

    if (viewBeforeUpdate === 'preview2') {
      if (this.lastPreview1Selection) {
        this.currentView = 'preview2';
        this.chargeSecondPreview(this.lastPreview1Selection);
        return;
      }

      this.refreshGridAfterUpdate();
      return;
    }

    this.refreshGridAfterUpdate();
  }

  reload(listData, subDomainJO, currentCountry, currentMatchKeyOld, currentMatchKeyNew) {
    this.sharedService.topPage();

    this.unselectItems();

    if (listData === undefined) {
      listData = [];
    }



    let fuentePascalCase = this.sharedService.convertSnakeCaseToPascalCase(subDomainJO);
    // console.log("fuentePascalCase", fuentePascalCase);

    let columnsVistaPrevia = [];
    if (subDomainJO == "DELINQUENCY_BOLAB") {
      // TODO: hacer esto dinámico en STRUCT o MENU
      listData = listData.sort(
        (a, b) => Number(b.debt_date) - Number(a.debt_date)
      );
    }

    // aplicar filtro py VIP
    if (this.currentCountry == "py" && subDomainJO == "DELINQUENCY_EXCH") {
      if (this.localStorageService.getIsVip) {
        // filtrar data para PY
        let dataFiltrada = listData.filter(filtro => filtro.tipo_registro === 'I' && (filtro.baja == null || filtro.baja == ""));
        listData = dataFiltrada;
      }
    }

    this.localStorageService.getEstructuraDinamicaField.sort((a: any, b: any) => a.order - b.order)
      .forEach((element) => {
        // console.log("fillEstructuraDinamicaHeaderAndColumnsVistaPrevia");
        // console.log(element, listData, columnsVistaPrevia);
        this.dataEstructuraFields(element, listData, columnsVistaPrevia);
      });


    this.divSubDomainJO.forEach((divSubDomainJOValue) => {
      if (divSubDomainJOValue.id === subDomainJO) {
        divSubDomainJOValue.vistaPrevia = columnsVistaPrevia;
        divSubDomainJOValue.showResultTable = true;
        divSubDomainJOValue.showVistaDetalle = false;
        divSubDomainJOValue.dataVistaPrevia = listData;
        divSubDomainJOValue.dataVistaPreviaFilter = listData;
      }
    });
    /// AGREGAR LOGICA de RDS //////
    if (this.localStorageService.getIsExternoRDS) {
      this.counterExternalRDS++;
      this.onActivate(listData[0], this.subDomainJO, false);
    }

    if (currentCountry === "ar") {
      // País con matchkey inicial y luego de modificar // TODO: hacer esto dinámico en STRUCT o MENU
      const resultNew = listData.find(
        ({ matchKey }) => matchKey === currentMatchKeyNew
      );
      // console.log("resultNew", resultNew);

      if (resultNew !== undefined) {
        this.onFuenteDinamicaSelected(resultNew, subDomainJO);
      } else {
        this.dialog.closeAll();
      }
    }
    if (currentCountry === "cl") {
      // TODO: hacer esto dinámico en STRUCT o MENU
      const resultOld = listData.find(
        ({ matchKey }) => matchKey === currentMatchKeyOld
      );
      // console.log("resultOld", resultOld);
      if (resultOld !== undefined) {
        this.onFuenteDinamicaSelected(resultOld, subDomainJO);
      } else {
        this.dialog.closeAll();
      }
    }

    setTimeout(() => {
      if (!this.localStorageService.getIsExternoRDS) {
        this.isEditing = false;
        this.addingObservatoin = false;
      }

      this.currentView = 'preview1'; // Asegura que la vista vuelva a 'preview1' después de recargar
      this.showLoading = false; // Asegura que el indicador de carga se oculte después de recargar
      this.cdr.detectChanges();
    });

  }

  handleFunction(event: any) {
    console.log("Function event received:", event);
    console.log("Current selected items:", this.selected);
    this.function = event;
    this.functionModalTitle = event?.name || 'Función';
    this.showFunctionModal = true;
    console.log("handleFunction struct:", this.structField);
  }

  handleSaveFunctionFromModal(fieldsToUpdateFromModal: any[]): void {
    this.handleMassUpdateRequest(fieldsToUpdateFromModal);
  }

  onViewSoftDeletedChange(value: boolean): void {
    setTimeout(() => {
      this.viewSoftDeleted = value;
      this.cdr.detectChanges();
    });
  }
}
